var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotUpdated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-pipeline-maintenance",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes wind{0%{transform:rotate(0deg)}25%{transform:rotate(1deg)}75%{transform:rotate(-1deg)}}svg#freepik_stories-pipeline-maintenance:not(.animated) .animable{opacity:0}svg#freepik_stories-pipeline-maintenance.animated #freepik--speech-bubble--inject-2{animation:1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown,1.5s Infinite linear wind;animation-delay:0s,1s}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Walls--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250.693px 243.015px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wall--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250.693px 243.015px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "388.275px 183.915px"
    },
    className: "animable",
    id: "eln7zasome4i"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "388.275px 183.915px"
    },
    id: "elav2frjv17a6",
    className: "animable",
    d: "m376.51 170.33 23.53 13.59v13.58l-23.53-13.58v-13.59z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "360.85px 168.145px"
    },
    className: "animable",
    id: "elyrkja3dcxb"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "360.85px 168.145px"
    },
    id: "eldc97kyswxsh",
    className: "animable",
    d: "m349.08 154.56 23.53 13.58.01 13.59-23.54-13.59v-13.58z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "374.725px 158.765px"
    },
    className: "animable",
    id: "elfsstegvbj3k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m363.68 146.43 22.08 12.75v11.91l-22.08-12.75v-11.91m-.72-1.25v13.58l23.53 13.59v-13.59L363 145.18Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "374.725px 158.765px"
    },
    id: "el5d5ac25nm8g",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "351.715px 254.675px"
    },
    className: "animable",
    id: "elvz31iiomvlg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "351.715px 254.675px"
    },
    id: "elhdqz0vue9l",
    className: "animable",
    d: "m339.95 241.09 23.53 13.58v13.59l-23.53-13.59v-13.58z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "472.055px 309.005px"
    },
    className: "animable",
    id: "eldgm9jb7wmw"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "472.055px 309.005px"
    },
    id: "el983sizczrhe",
    className: "animable",
    d: "m460.29 295.42 23.52 13.59.01 13.58-23.53-13.58v-13.59z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "324.295px 238.905px"
    },
    className: "animable",
    id: "elqxwoo23mr6p"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "324.295px 238.905px"
    },
    id: "eldlhnmjfyrll",
    className: "animable",
    d: "m312.53 225.32 23.53 13.58v13.59l-23.53-13.59v-13.58z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "467.22px 235.335px"
    },
    className: "animable",
    id: "elti444u17i2r"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "467.22px 235.335px"
    },
    id: "ela3kznhiq7jn",
    className: "animable",
    d: "m455.45 221.75 23.53 13.59.01 13.58-23.54-13.58v-13.59z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "338.165px 229.515px"
    },
    className: "animable",
    id: "elu9gor0xkhd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m327.13 217.19 22.07 12.74v11.92l-22.07-12.75v-11.91m-.73-1.26v13.59l23.53 13.58v-13.58l-23.53-13.59Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "338.165px 229.515px"
    },
    id: "el995njqx8kfm",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "456.78px 80.265px"
    },
    className: "animable",
    id: "elv392wh3v7l"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "456.78px 80.265px"
    },
    id: "el0kilpj9s1d9",
    className: "animable",
    d: "m445.01 66.68 23.53 13.59.01 13.58-23.54-13.58V66.68z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "429.355px 64.495px"
    },
    className: "animable",
    id: "eli7jahfuo93"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "429.355px 64.495px"
    },
    id: "elwahnpyh5ld8",
    className: "animable",
    d: "m417.59 50.91 23.53 13.58v13.59l-23.53-13.59V50.91z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "443.23px 55.115px"
    },
    className: "animable",
    id: "elrfpkamasfxi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m432.19 42.78 22.08 12.75v11.91l-22.08-12.75V42.78m-.73-1.25v13.58L455 68.7V55.11l-23.54-13.58Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "443.23px 55.115px"
    },
    id: "elo0kshjj2ora",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "366.435px 47.4px"
    },
    className: "animable",
    id: "elyw9k16oslsq"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "366.435px 47.4px"
    },
    id: "el631gvfnh16k",
    className: "animable",
    d: "M354.67 33.82 378.2 47.4v13.58L354.67 47.4V33.82z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "382.615px 232.915px"
    },
    className: "animable",
    id: "elgcjz1d2cdwq"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "382.615px 232.915px"
    },
    id: "ely8msb4x1vdq",
    className: "animable",
    d: "m370.85 219.33 23.53 13.58v13.59l-23.53-13.59v-13.58z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.06 452.21a.5.5 0 0 1-.25-.93l251.84-145.41a.51.51 0 0 1 .69.19.5.5 0 0 1-.19.68L18.31 452.14a.47.47 0 0 1-.25.07Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "143.985px 379.008px"
    },
    id: "el1kq6fg6kyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "45.545px 393.695px"
    },
    className: "animable",
    id: "elmjgelh7vrsb"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "45.545px 393.695px"
    },
    id: "ellbthe1v7z",
    className: "animable",
    d: "m57.31 380.11-23.52 13.58-.01 13.59 23.53-13.59v-13.58z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "57.705px 370.21px"
    },
    className: "animable",
    id: "elntdarjq7jl8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "57.705px 370.21px"
    },
    id: "el8vcklpwiaph",
    className: "animable",
    d: "m69.47 356.63-23.52 13.58-.01 13.58 23.53-13.58v-13.58z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "31.525px 385.34px"
    },
    className: "animable",
    id: "elgbyomb6zzp6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.57 373v11.91l-22.08 12.76v-11.91L42.57 373m.72-1.25-23.53 13.59v13.59l23.53-13.59v-13.58Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "31.525px 385.34px"
    },
    id: "elz2rukkhl07",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "152.085px 181.415px"
    },
    className: "animable",
    id: "eldyulte20nf"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "152.085px 181.415px"
    },
    id: "elnxgb1pz621",
    className: "animable",
    d: "m163.85 167.83-23.53 13.59V195l23.53-13.58v-13.59z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "179.505px 165.645px"
    },
    className: "animable",
    id: "elokx671s0qj8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "179.505px 165.645px"
    },
    id: "el9oqntb0g86e",
    className: "animable",
    d: "m191.27 152.06-23.52 13.58-.01 13.59 23.53-13.59v-13.58z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "165.625px 156.265px"
    },
    className: "animable",
    id: "elzcwm20xxyql"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.68 143.93v11.91l-22.09 12.75v-11.91l22.08-12.75m.72-1.25-23.53 13.58v13.59l23.53-13.59v-13.58Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "165.625px 156.265px"
    },
    id: "elrbheomnp0il",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "167.385px 303.97px"
    },
    className: "animable",
    id: "el7ldcsy5q7t9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "167.385px 303.97px"
    },
    id: "el32luurdpk12",
    className: "animable",
    d: "m179.15 290.38-23.53 13.59v13.59l23.53-13.59v-13.59z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "67.975px 250.885px"
    },
    className: "animable",
    id: "elcxthzy1ur2s"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "67.975px 250.885px"
    },
    id: "elqt5qslnod3",
    className: "animable",
    d: "m79.74 237.3-23.53 13.58v13.59l23.53-13.59V237.3z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "194.805px 288.195px"
    },
    className: "animable",
    id: "elcj85im3qap9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "194.805px 288.195px"
    },
    id: "ele79t8so12mn",
    className: "animable",
    d: "m206.57 274.61-23.53 13.58v13.59l23.53-13.58v-13.59z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "82.76px 260.715px"
    },
    className: "animable",
    id: "elqamufezgxu"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "82.76px 260.715px"
    },
    id: "elbgp5d5ii1mm",
    className: "animable",
    d: "M94.53 247.13 71 260.71l-.01 13.59 23.54-13.59v-13.58z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "180.965px 278.815px"
    },
    className: "animable",
    id: "el44fa5clwr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192 266.48v11.91l-22.08 12.75v-11.91L192 266.48m.73-1.25-23.53 13.58v13.59l23.53-13.59v-13.58Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "180.965px 278.815px"
    },
    id: "elrl0ufr5mpjm",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "135.785px 75.055px"
    },
    className: "animable",
    id: "el5esrcbmiynj"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "135.785px 75.055px"
    },
    id: "el1ato10ajgjzh",
    className: "animable",
    d: "m147.55 61.47-23.53 13.58v13.59l23.53-13.59V61.47z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "38.365px 85.945px"
    },
    className: "animable",
    id: "ellu0zp6gim1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "38.365px 85.945px"
    },
    id: "elyc8glpa92eh",
    className: "animable",
    d: "M50.13 72.36 26.61 85.94l-.01 13.59 23.53-13.59V72.36z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "163.205px 59.285px"
    },
    className: "animable",
    id: "ele15hjwm6h5c"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "163.205px 59.285px"
    },
    id: "ely2ft00bt58e",
    className: "animable",
    d: "m174.97 45.7-23.53 13.58v13.59l23.53-13.59V45.7z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "53.155px 95.775px"
    },
    className: "animable",
    id: "elu29t8pgde2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "53.155px 95.775px"
    },
    id: "elmbxgvdl7ar",
    className: "animable",
    d: "M64.92 82.19 41.39 95.77v13.59l23.53-13.59V82.19z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "149.335px 49.895px"
    },
    className: "animable",
    id: "elwfzxmqt0vt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.38 37.57v11.91l-22.09 12.75V50.31l22.08-12.74m.72-1.26L137.57 49.9v13.58L161.1 49.9V36.31Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "149.335px 49.895px"
    },
    id: "elbefodlaky8",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "49.555px 168.305px"
    },
    className: "animable",
    id: "elay3tgzd4bb"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "49.555px 168.305px"
    },
    id: "elmc1as8414h",
    className: "animable",
    d: "M61.32 154.72 37.8 168.31l-.01 13.58 23.53-13.58v-13.59z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "179.585px 108.075px"
    },
    className: "animable",
    id: "ele0v13xf0vd5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "179.585px 108.075px"
    },
    id: "el35fgsbuuxd9",
    className: "animable",
    d: "m191.35 94.49-23.53 13.58v13.59l23.53-13.59V94.49z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "179.585px 242.085px"
    },
    className: "animable",
    id: "el6cixpnd820b"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "179.585px 242.085px"
    },
    id: "el9t2369nyz6w",
    className: "animable",
    d: "m191.35 228.5-23.53 13.58v13.59l23.53-13.59V228.5z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "35.41px 193.125px"
    },
    className: "animable",
    id: "elck9x55a3vpk"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "35.41px 193.125px"
    },
    id: "elzvkkpdcozv",
    className: "animable",
    d: "m47.18 179.54-23.53 13.59-.01 13.58 23.54-13.58v-13.59z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "49.565px 202.685px"
    },
    className: "animable",
    id: "elq3ois7ia7ip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6 190.36v11.91L38.52 215v-11.9l22.08-12.74m.72-1.26L37.8 202.69v13.58l23.53-13.58V189.1Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "49.565px 202.685px"
    },
    id: "elk3ejdjvuj1o",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2",
    className: "animable",
    style: {
      transformOrigin: "275.23px 282.427px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-2",
    cx: 328.55,
    cy: 318.26,
    rx: 53.01,
    ry: 30.72,
    style: {
      fill: "#e6e6e6",
      transformOrigin: "328.55px 318.26px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-2",
    cx: 426.42,
    cy: 419.31,
    rx: 56.14,
    ry: 32.53,
    style: {
      fill: "#e6e6e6",
      transformOrigin: "426.42px 419.31px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 304.75,
    cy: 417.81,
    rx: 30.35,
    ry: 17.59,
    style: {
      fill: "#e6e6e6",
      transformOrigin: "304.75px 417.81px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.44 458.56a4.71 4.71 0 0 0-.82-2.89 2.43 2.43 0 0 0-.3-.34 2.9 2.9 0 0 0-.53-.41h-.05l.06-.42c0-.37.06-.73.08-1.11s0-.51 0-.76V450.76c0-.59-.11-1.19-.21-1.78 0-.22-.09-.44-.14-.66-.07-.38-.15-.76-.24-1.13s-.17-.56-.25-.84-.19-.61-.3-.92-.22-.57-.33-.86-.23-.56-.36-.83-.27-.58-.42-.86l-.42-.78c-.17-.28-.33-.56-.51-.84s-.32-.48-.48-.71-.38-.55-.59-.82-.36-.43-.54-.65a21.52 21.52 0 0 0-2.77-2.71c-.21-5.17-2.14-8.82-5.19-10.55l-4.81-2.82c-2.35-1.36-5.36-1.58-8.74-.48l-11-6.31-18-10.4-4-2.31-.28-.14.28.13-1.27-.73-3.63-2.1-22-12.72-13.87-8-.73-.42-4.5-2.6a12 12 0 0 1-6-10.39v-13.15a1.34 1.34 0 0 0 0-.2v-1.47a1.34 1.34 0 0 1 0 .2v-35.4a10.16 10.16 0 0 0 3.29-7.14v-5.63a10.09 10.09 0 0 0-3.14-7v-41.1a1.34 1.34 0 0 0 0-.2V254a1.34 1.34 0 0 1 0 .2 4.78 4.78 0 0 1-.06.53 5.51 5.51 0 0 0 .06-.7V206.7a1.34 1.34 0 0 0 0-.2V205a1.34 1.34 0 0 1 0 .2v.14-46.43a1.34 1.34 0 0 0 0-.2v-1.47a1.34 1.34 0 0 1 0 .2v.14-4.82a48.56 48.56 0 0 0-6.51-24.28c-.47-.82-1-1.62-1.49-2.4l-.48-.7c-.39-.58-.8-1.14-1.21-1.7l-.51-.68c-.58-.74-1.17-1.47-1.79-2.18s-1.42-1.58-2.16-2.33-1.52-1.47-2.32-2.17l-.52-.44c-.88-.75-1.8-1.47-2.73-2.16a48.79 48.79 0 0 0-4.57-3l-6.37-3.72-7.65-4.42A10.17 10.17 0 0 0 102.8 96L98 93.28c-3.2-1.85-7.61-1.59-12.49 1.22-9.72 5.62-17.61 19.29-17.61 30.5 0 5.63 2 9.58 5.16 11.42l4.88 2.81a9.93 9.93 0 0 0 7.27.86l10.72 6.19.09.07.2.11a12.24 12.24 0 0 1 1.39 1 12 12 0 0 1 4.54 9.39v.63a2.35 2.35 0 0 1 0-.26V205.28a2.44 2.44 0 0 1 0-.27V254a8.26 8.26 0 0 0 .08 1c0-.15-.06-.3-.07-.45v-.33a2.44 2.44 0 0 1 0-.27v42.77a10.1 10.1 0 0 0-3.16 7.09v5.53a10 10 0 0 0 3 6.88V352v-.27V370.68a48.47 48.47 0 0 0 5 21.5c.47.94 1 1.87 1.48 2.78a48.61 48.61 0 0 0 17.77 17.77l8.74 5 4 2.3 71.29 41.15a9.69 9.69 0 0 0 4.07 5l4.88 2.81a9.74 9.74 0 0 0 6.8.95l.12.07a20.49 20.49 0 0 0 21.06-.34c.5-.3 1-.64 1.44-1l.1.06a4 4 0 0 0 4-.39 6.64 6.64 0 0 0 .89.05 6.12 6.12 0 0 0 4.73-9.83Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "163.762px 282.427px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2",
    className: "animable",
    style: {
      transformOrigin: "304.756px 199.286px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "304.756px 199.286px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-2",
    className: "animable",
    style: {
      transformOrigin: "326.034px 252.428px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.6 258.44c-1.36-12.64-3.65-16.9-3.92-19.34 0 0-.14-28.73-1.88-56.41-.58-9.19-1.75-12.36-3.94-17.47h-49.53c-.1 1.86-.24 3.71-.48 5.57v.17c-2.71 20.94 0 48.13.57 63 .33 9 3 46 3 46 6.31 4 15.46 1.1 15.46 1.1s2.91-21.35 3.61-28.8a62 62 0 0 0-.24-14.43l4.33-22.48s2.37 16.05 5.54 26.92c3.49 12 10.15 35.16 13.29 44.08 7.28 2.45 15.56-1.58 15.56-1.58s-.18-15.28-1.37-26.33Z",
    style: {
      fill: "#37474f",
      transformOrigin: "331.818px 226.18px"
    },
    id: "elrnrlj3wmz2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.33 246.12a43.28 43.28 0 0 1-2.18-9.76c-.43-6.18-1.59-29.72-2.35-45.3a74.74 74.74 0 0 0-1.18-10.27 44.24 44.24 0 0 0-5.87-15.51H344a43.41 43.41 0 0 1 5.92 15.31 11.41 11.41 0 0 1-8.13-2.82c-3.28-3-4-6-5-10q-.3-1.22-.66-2.52h-.7c.25.92.49 1.81.7 2.66 1 4.12 1.8 7.1 5.22 10.27a11.94 11.94 0 0 0 8.37 3h.28a73.55 73.55 0 0 1 1.12 9.94c.77 15.58 1.92 39.12 2.35 45.31a43.5 43.5 0 0 0 2.2 9.89c.94 3.1 2 6.61 3 11.43 2.14 10.41 1.72 27.67 1.72 27.84a.32.32 0 0 0 .33.31.32.32 0 0 0 .33-.3c0-.17.43-17.5-1.73-28-.99-4.84-2.05-8.37-2.99-11.48Z",
    style: {
      fill: "#455a64",
      transformOrigin: "348.257px 225.575px"
    },
    id: "el624wj5bdw0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.86 308c.64.76.29 1.69-.51 2.59s-4.5 2-6.89 2.91a21 21 0 0 0-7.24 3.9 20 20 0 0 1-10.9 4.41c-5.94.66-9.36-.55-10.72-1.91s-1.33-3.76-.14-4.66 9.68-5.16 17.77-7.11 18.63-.13 18.63-.13Z",
    style: {
      fill: "#263238",
      transformOrigin: "301.382px 314.612px"
    },
    id: "el5ykn7alr6qk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.34 269.75-.31 2.37s-3.29 1.89-9.64 1.58-7.68-3.43-7.68-3.43l-.15-2.07s-1.85.2-1.25 3.81 1.54 20.94 1.32 22.89-3 6-8.78 10.21-13.61 6.87-13.49 10.14 4.69 5.51 11.33 4.88c8.44-.8 11.11-4.55 15.52-6.82s8.74-3.21 9.9-4.53 1.6-1.52 1.13-6.95-.3-7.53 1.26-16.94 1.81-10.52 2-12.7-1.16-2.44-1.16-2.44Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "302.938px 294.218px"
    },
    id: "eludls4fxq07a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.34 269.75-.31 2.37s-3.29 1.89-9.64 1.58-7.68-3.43-7.68-3.43l-.15-2.07s-1.85.2-1.25 3.81 1.54 20.94 1.32 22.89-3 6-8.78 10.21-13.61 6.87-13.49 10.14 4.69 5.51 11.33 4.88c8.44-.8 11.11-4.55 15.52-6.82s8.74-3.21 9.9-4.53 1.6-1.52 1.13-6.95-.3-7.53 1.26-16.94 1.81-10.52 2-12.7-1.16-2.44-1.16-2.44Z",
    style: {
      opacity: 0.2,
      transformOrigin: "302.938px 294.218px"
    },
    className: "animable",
    id: "elmegdpbpvz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.55 215.26-4.4-27.26a18.43 18.43 0 0 1-14.6-6.23s0 6.84 11.78 9.64l5 25.09-2.15 21.23Z",
    style: {
      fill: "#263238",
      transformOrigin: "319.05px 209.75px"
    },
    id: "elcdzzye1h029",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.75 320.53c1.2 4.79 2.24 12.94-3.21 16.82s-9.82 2-11.1.33-2.27-3.21-2.58-9.26Z",
    style: {
      fill: "#263238",
      transformOrigin: "360.785px 330.083px"
    },
    id: "elglxlr68iwna",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.53 277.5.47 1.5s3.28 1.26 9.09.4 8.63-3.54 8.63-3.54l-.07-2.38s1.69.16 1.65 2.88-.27 19.72.1 23.18a71 71 0 0 0 2.75 14.88 38.44 38.44 0 0 1 2.16 11.65c0 3.18-.81 9.94-8.52 11.4-8.73 1.65-8.84-6.35-9.17-13-.24-4.95-.17-13.09-1-18.83s-5.16-18.2-5.95-22c-.84-4-1.47-5.59-.14-6.14Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "356.536px 305.584px"
    },
    id: "elt3e6zc7jx6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.53 277.5.47 1.5s3.28 1.26 9.09.4 8.63-3.54 8.63-3.54l-.07-2.38s1.69.16 1.65 2.88-.27 19.72.1 23.18a71 71 0 0 0 2.75 14.88 38.44 38.44 0 0 1 2.16 11.65c0 3.18-.81 9.94-8.52 11.4-8.73 1.65-8.84-6.35-9.17-13-.24-4.95-.17-13.09-1-18.83s-5.16-18.2-5.95-22c-.84-4-1.47-5.59-.14-6.14Z",
    style: {
      opacity: 0.2,
      transformOrigin: "356.536px 305.584px"
    },
    className: "animable",
    id: "elzora7ynjce"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-2",
    className: "animable",
    style: {
      transformOrigin: "304.756px 121.679px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-2",
    className: "animable",
    style: {
      transformOrigin: "277.938px 111.934px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.82 118.27a13.85 13.85 0 0 0 2.8-2.08 10.52 10.52 0 0 0 3.22-6.85l-1.45-.78c-2.14-1.23-2.72-4.58-4.62-7.41a43.33 43.33 0 0 1-3.54-6c-1-2.1-2.39-1.82-2.91-.25s.78 4.56.66 5-3.53-1.5-5.7-3.55-2.53-4.9-3.72-5.7a1.83 1.83 0 0 0-2.11-.11l.09 4s-1.35-.43-1.49 3.27.31 6.57 3 9.67a16.93 16.93 0 0 0 5.92 4.71c2.1 1.21 4.37 1.93 7 4 .53.39 1.54 1.13 2.85 2.08Z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "251.434px 104.264px"
    },
    id: "el787lk3cav7v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.94 104.83c-4.12.18-7-.71-13.33 2.14-2.62 1.19-22.85 10.88-22.85 10.88L263.28 108a16.89 16.89 0 0 1-.4 3.4c-1.21 3.75-3.49 5.52-6.05 7.09 5.72 4.13 15.76 12.29 18.47 13.92 3.71 2.24 6.6 1 12-.89s21.53-7 21.53-7 11.23-19.86 7.11-19.69Z",
    style: {
      fill: "#37474f",
      transformOrigin: "286.839px 119.22px"
    },
    id: "elza2yct63zsf",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-2",
    className: "animable",
    style: {
      transformOrigin: "327.765px 139.462px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.56 104.55s17.52.77 21.91 2.71c2 .89 6.43 6 5.67 18.53-.31 5-2.22 15.31-2.22 19.07 0 5.33 4.9 22.57 4.9 22.57-16.31 10.28-45.39 7.51-51.34 2.17 0 0 1.75-22.37 2.24-33.87 0 0-3.21-5.26-3-8.83.32-5.25 1.39-7.12 6.12-13a98.1 98.1 0 0 1 8.09-9Z",
    style: {
      fill: "#455a64",
      transformOrigin: "327.765px 139.462px"
    },
    id: "elo266zh01fss",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M338.89 68.31c5.66.56 7.13 9.77 5.84 15-2.47 10.07-9.23 11.32-9.45 15.61l-10.21-5.84-7.95-4.54c-2.09-1.19-3.49-1.6-5.64-2.86A5.89 5.89 0 0 1 309 83.3c-.51-1.35-.53-2.59.35-3.33-1.25.66-2.12.74-3.16 0a2.51 2.51 0 0 1-.8-2.63c.28.49 1.36.49 1.44-.68a3.65 3.65 0 0 1 2.52-3.54c4.85-10.93 15-13.7 19-12.87 4.48.93 9.14 3.42 10.54 8.06Z",
    style: {
      fill: "#263238",
      transformOrigin: "325.227px 79.5164px"
    },
    id: "elw6zp2lryced",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.1 96.94c.3-1.44 1.65-1.67 2.88-2 4.78-1.27 5-7.84.77-10a5.68 5.68 0 0 0-.51-4.88 6.78 6.78 0 0 0-5.77-3.26l-8.32 20.86a3.26 3.26 0 0 0 2.12 3.54c2.23.78 3.79-.38 5.07-2a2.35 2.35 0 0 1-2 3.06c2.26 1.65 4.08 0 5.27-2 .67-1.21.23-2.08.49-3.32Z",
    style: {
      fill: "#263238",
      transformOrigin: "342.935px 89.8675px"
    },
    id: "el8i7w3l2ecx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.09 103 .46-9.32a4.07 4.07 0 0 0 5-1.06c2.75-2.91 3-6.06 1.44-8.07-1.7-2.21-5.4-1.32-7 1.42-2.42.6-3.44-2.85-1.64-6.42 0 0-12.36 6-17.26-7.92-1.49-1.37-3.45-.22-4.23 1.64s-2.14 5.46-1.83 13.36c.35 8.85 2.88 11.47 5.32 12.94 1.53.91 3.67 1.16 6.26 1.14l-.11 2.58c0 1.3-.34 1.35-1.46 1.42l-1.68.12s-4.14 5 3.9 5.91c12 1.42 18.44-4.59 18.44-4.59s-.75-.12-2.81-.4-2.61-1.07-2.8-2.75Z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "326.467px 90.9927px"
    },
    id: "elavt3mued1wh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.06 104.66a49.18 49.18 0 0 0-13.68 29.4c-.83 9.64-.63 49.49-.63 49.49s-5.57.07-8.18-1.77c1.26-22.11 2.56-43.77 3.52-54.84a22.6 22.6 0 0 1 3.68-10 45.38 45.38 0 0 1 10.92-12.08Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "308.815px 144.105px"
    },
    id: "elan65jctg8eq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.47 104.4c1.26 2.73-2.79 18.86-2.8 27.82 0 16.24 5.44 52.2 5.44 52.2s11.68-.31 18.93-5.52c0-3.91-3.46-17.59-5.17-23.26a42.55 42.55 0 0 1-.39-21.94c2-9.06.37-20.29-3.91-26.55Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "344.855px 144.41px"
    },
    id: "elc9iv92zmkg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.38 172.18c9.56-.86 15.6-3.43 18.53-5.05-.25-1-.49-2.07-.77-3.14-3.82 2-11.72 4.25-18.19 4.9.15 1.11.29 2.24.43 3.29Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "345.43px 168.085px"
    },
    id: "elmqq9phze0c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.26 91.44a1.21 1.21 0 1 1-1.2-1.22 1.2 1.2 0 0 1 1.2 1.22Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "338.05px 91.43px"
    },
    id: "elr3vtx4ebja",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.53 91.27-4.3 1.44a2.22 2.22 0 0 0 2.83 1.51 2.37 2.37 0 0 0 1.47-2.95Z",
    style: {
      fill: "#b16668",
      transformOrigin: "322.435px 92.8004px"
    },
    id: "elkll46rmpwe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.27 92.27a2.5 2.5 0 0 0-2.47 2 2.26 2.26 0 0 0 1.26 0 2.33 2.33 0 0 0 1.55-1.91 1.86 1.86 0 0 0-.34-.09Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "323.205px 93.3148px"
    },
    id: "eln917pjq3vfr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.89 80.71 3.18-1.46a1.69 1.69 0 0 0-2.27-.9 1.85 1.85 0 0 0-.91 2.36Z",
    style: {
      fill: "#263238",
      transformOrigin: "313.412px 79.4531px"
    },
    id: "ele7mu4ulhc3w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.23 80-3.12-1.65a1.69 1.69 0 0 1 2.33-.78 1.86 1.86 0 0 1 .79 2.43Z",
    style: {
      fill: "#263238",
      transformOrigin: "325.76px 78.6852px"
    },
    id: "el8diax4hvyme",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0997a",
      transformOrigin: "317.16px 85.685px"
    },
    id: "elk4hbcw4dmk7",
    className: "animable",
    d: "m319.7 81.09-.34 9.19-4.74-1.88 5.08-7.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.69 82.77a1.5 1.5 0 0 1-1.32 1.61 1.4 1.4 0 0 1-1.58-1.26 1.51 1.51 0 0 1 1.32-1.61 1.41 1.41 0 0 1 1.58 1.26Z",
    style: {
      fill: "#263238",
      transformOrigin: "314.24px 82.9456px"
    },
    id: "el7wpuoutxpqt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.24 82.87a1.51 1.51 0 0 1-1.32 1.61 1.41 1.41 0 0 1-1.58-1.27 1.49 1.49 0 0 1 1.32-1.6 1.4 1.4 0 0 1 1.58 1.26Z",
    style: {
      fill: "#263238",
      transformOrigin: "324.79px 83.0443px"
    },
    id: "el4cmnhcrwxxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.63 100.66c5.52-.65 10.79-2.54 12-5.08a5 5 0 0 1-2.16 4.11c-3.12 1.89-9.91 2.92-9.91 2.92Z",
    style: {
      fill: "#f0997a",
      transformOrigin: "327.595px 99.095px"
    },
    id: "elyw03b41vent",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "306.375px 160.31px"
    },
    id: "elabauh8pred7",
    className: "animable",
    d: "m278.43 138.18 37.06 2.5 18.83 41.76-35.4-3.28-20.49-40.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.72 166.86a8.55 8.55 0 0 0 6.62 5.5 34.37 34.37 0 0 0 10.21-.5l-2.16-4.79Z",
    style: {
      opacity: 0.15,
      transformOrigin: "321.135px 169.696px"
    },
    className: "animable",
    id: "elim46rpb9dql"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290 142.53-.55-1.29c-.31-.71 1.76-1.14 4.61-1l5.45.35c2.85.18 5.41.9 5.71 1.62l.55 1.28Z",
    style: {
      opacity: 0.15,
      transformOrigin: "297.595px 141.852px"
    },
    className: "animable",
    id: "elgrffsls5qtm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.56 137.93c-.2-.45.62-.73 1.82-.63l2.16.17s-1.17-2.79 3.59-2.65 6.4 3.24 6.4 3.24l2.31.2c1.28.11 2.51.56 2.74 1l.42.79-19.08-1.29Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "296.265px 137.432px"
    },
    id: "eldvj238ulduk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.56 137.93c-.2-.45.62-.73 1.82-.63l2.16.17s-1.17-2.79 3.59-2.65 6.4 3.24 6.4 3.24l2.31.2c1.28.11 2.51.56 2.74 1l.42.79-19.08-1.29Z",
    style: {
      opacity: 0.3,
      transformOrigin: "296.265px 137.432px"
    },
    className: "animable",
    id: "ell1t90l0c4q9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 142.41c-.25-.59-2.06-1.18-4.3-1.47a2.2 2.2 0 0 0-.09-.21c-.25-.62-.05-1.06 1.3-1v-.53l-13.22-.79.64.46c1.74.08 2.47.17 2.94 1.27l.11.25c-2.06 0-3.41.41-3.16 1s.55 1.29.55 1.29l15.77 1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "297.115px 141.045px"
    },
    id: "elycsb8y0taed",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 142.41c-.25-.59-2.06-1.18-4.3-1.47a2.2 2.2 0 0 0-.09-.21c-.25-.62-.05-1.06 1.3-1v-.53l-13.22-.79.64.46c1.74.08 2.47.17 2.94 1.27l.11.25c-2.06 0-3.41.41-3.16 1s.55 1.29.55 1.29l15.77 1Z",
    style: {
      opacity: 0.4,
      transformOrigin: "297.115px 141.045px"
    },
    className: "animable",
    id: "el217834az93h"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337 154.12a18.6 18.6 0 0 1-3.55.81 27.29 27.29 0 0 1-3.25-.22 28.93 28.93 0 0 0-3.06-.45c-1.12 0-2.24.18-3.36.23a20.82 20.82 0 0 1-2.15-.09l1.72 3.8.3.1c.94.3.37 1-.26 1.32a14.81 14.81 0 0 1-5.79 1.41 33.27 33.27 0 0 1-6-.32 3.64 3.64 0 0 0-1 0 1.18 1.18 0 0 0-.86.53 1.24 1.24 0 0 0 .15 1.3 4.5 4.5 0 0 0 1 .92 2.75 2.75 0 0 1 .91 1c.26.63.08 1.39.43 2s1.32.8 2 1.24a8.66 8.66 0 0 1 1.36 1.53 5.85 5.85 0 0 0 2.74 1.62c2.92.85 5.77.35 8.68-.23 6.18-1.24 10-4.37 14.18-6.61.34-7.41-4.19-9.89-4.19-9.89Z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "325.415px 162.712px"
    },
    id: "el8r9s70yrpg2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.48 106.64c5.1.71 9.49.56 12.37 5a47.34 47.34 0 0 1 4.84 10.14c2.82 7 5.11 12.07 7.16 18a62.31 62.31 0 0 1 2.4 8.79c.74 3.66-.27 5.79-3.13 7.38-2.47 1.36-5.19 2.44-11.19 4.2-8.78 2.57-10.72 3.17-14.91 4.28a17.58 17.58 0 0 0-5-10.49s3.21-1.23 7.22-2.94c7.3-3.13 11.2-5 11.2-5s-8-14.42-10.49-20.17c-3.54-8.26-.47-19.19-.47-19.19Z",
    style: {
      fill: "#37474f",
      transformOrigin: "353.252px 135.535px"
    },
    id: "el4ftu9hpfcs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.62 143.48c3.95.12 5 1.45 5 1.45a15.77 15.77 0 0 0-10.15 1l-.78-1.41a14 14 0 0 1 5.93-1.04Z",
    style: {
      fill: "#263238",
      transformOrigin: "359.155px 144.699px"
    },
    id: "el71pg9kyuzz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.65 80.86A19 19 0 0 1 344 86a16.61 16.61 0 0 0-1.19-1.53 31.25 31.25 0 0 0-8.63-6.86c-7.54-4.18-17-6.06-24.79-4.46a17.83 17.83 0 0 1 1.72-4.28 18.55 18.55 0 0 1 34.54 12Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "327.645px 72.6423px"
    },
    id: "elwusm2t4akhk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.92 61.9c-.9-.52-5.47-2.23-5.83-2.37-2.37-.9-6.25-1.12-10.47 1.88a18.9 18.9 0 0 0-6.94 9.66l4.85 1.93 1.58.27c.83-3.61 6.18-11.13 12.94-11a5.26 5.26 0 0 1 1 .08 8.77 8.77 0 0 1 2.57.71 25.1 25.1 0 0 1 2.48 2.28 4.15 4.15 0 0 0-2.18-3.44Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "328.39px 66.1039px"
    },
    id: "eliumtngpc56",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.92 61.9c-.9-.52-5.47-2.23-5.83-2.37-2.37-.9-6.25-1.12-10.47 1.88a18.9 18.9 0 0 0-6.94 9.66l4.85 1.93 1.58.27c.83-3.61 6.18-11.13 12.94-11a5.26 5.26 0 0 1 1 .08 8.77 8.77 0 0 1 2.57.71 25.1 25.1 0 0 1 2.48 2.28 4.15 4.15 0 0 0-2.18-3.44Z",
    style: {
      fill: "#fff",
      opacity: 0.45,
      transformOrigin: "328.39px 66.1039px"
    },
    className: "animable",
    id: "eltgskjgrkak"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.1 73.23c1-4.19 8.14-13.79 16.48-10.18a25.25 25.25 0 0 1 2.48 2.28 4.18 4.18 0 0 0-2.14-3.44c-2.16-1.22-6.58-2-11.46 1.43a18.81 18.81 0 0 0-6.92 9.68Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "330.8px 67.0413px"
    },
    id: "ela05r9om93bj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.1 73.23c1-4.19 8.14-13.79 16.48-10.18a25.25 25.25 0 0 1 2.48 2.28 4.18 4.18 0 0 0-2.14-3.44c-2.16-1.22-6.58-2-11.46 1.43a18.81 18.81 0 0 0-6.92 9.68Z",
    style: {
      opacity: 0.3,
      transformOrigin: "330.8px 67.0413px"
    },
    className: "animable",
    id: "elpvukjotze5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.42 76.14a20.82 20.82 0 0 0-7.74-7.89c-3.68-2.25-11.44-2.92-14.93-3.11-6.13-.32-7.68.88-7.81 1.78 0 .21-.19 1.19-.23 1.42a.89.89 0 0 0 .08.59c.82 1.45 5.6 4.19 5.6 4.19 7.79-1.6 17.25.28 24.79 4.46Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "319.056px 71.3336px"
    },
    id: "elnixiuow4ey",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.42 76.14a20.82 20.82 0 0 0-7.74-7.89c-3.68-2.25-11.44-2.92-14.93-3.11-6.13-.32-7.68.88-7.81 1.78 0 .21-.19 1.19-.23 1.42a.89.89 0 0 0 .08.59c.82 1.45 5.6 4.19 5.6 4.19 7.79-1.6 17.25.28 24.79 4.46Z",
    style: {
      opacity: 0.15,
      transformOrigin: "319.056px 71.3336px"
    },
    className: "animable",
    id: "ellahvwzxg62g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.18 77.58c-7.54-4.18-17-6.06-24.79-4.46 0 0-4.78-2.74-5.6-4.19-.43-.81.14-2.74 7.72-2.34 3.49.18 11.27.82 14.93 3.11a20.76 20.76 0 0 1 7.74 7.88Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "318.932px 72.058px"
    },
    id: "elug1iapbaaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.18 77.58c-7.54-4.18-17-6.06-24.79-4.46 0 0-4.78-2.74-5.6-4.19-.43-.81.14-2.74 7.72-2.34 3.49.18 11.27.82 14.93 3.11a20.76 20.76 0 0 1 7.74 7.88Z",
    style: {
      opacity: 0.3,
      transformOrigin: "318.932px 72.058px"
    },
    className: "animable",
    id: "el5ayjewdmcd4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pipelines--inject-2",
    className: "animable",
    style: {
      transformOrigin: "182.115px 247.918px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pipelines--inject-2",
    className: "animable",
    style: {
      transformOrigin: "182.115px 247.918px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pipes--inject-2",
    className: "animable",
    style: {
      transformOrigin: "67.32px 375.422px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drain--inject-2",
    className: "animable",
    style: {
      transformOrigin: "77.83px 369.437px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "86.605px 428.806px"
    },
    className: "animable",
    id: "elae06u2p2u5t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.68 423.55c-5-2.91-13.14-2.91-18.16 0-2.51 1.44-3.76 3.36-3.76 5.26s1.25 3.81 3.76 5.26c5 2.9 13.14 2.9 18.16 0 2.51-1.45 3.77-3.36 3.77-5.27s-1.26-3.8-3.77-5.25Z",
    id: "elxpdpc1ad4t",
    className: "animable",
    style: {
      transformOrigin: "86.605px 428.806px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "72.35px 364.954px"
    },
    className: "animable",
    id: "eluw4byg4sbg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.45 336.4v-4.65a13.08 13.08 0 0 0-6.53-11.32l-6-3.49c0-2.32-.82-3.95-2.14-4.71l-5.13-3c-1.32-.77-3.14-.66-5.16.5a16.1 16.1 0 0 0-7.28 12.61c0 2.32.82 3.95 2.13 4.71l5.15 3c1.32.76 3.13.65 5.14-.5l4.37 2.53a1.83 1.83 0 0 1 .92 1.59v84.1a5.59 5.59 0 0 0-2.92 3.4l17.49-10.1Z",
    id: "el8jj74xi1crh",
    className: "animable",
    style: {
      transformOrigin: "72.35px 364.954px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m70.79 303.12 5.14 3-10.3 17.83-5.14-3c-1.32-.76-2.14-2.39-2.14-4.71a16.08 16.08 0 0 1 7.28-12.61c2.02-1.17 3.84-1.28 5.16-.51Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "67.14px 313.289px"
    },
    id: "eljgvi6a7lli9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "67.14px 313.289px"
    },
    className: "animable",
    id: "el025che9x2x4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m70.79 303.12 5.14 3-10.3 17.83-5.14-3c-1.32-.76-2.14-2.39-2.14-4.71a16.08 16.08 0 0 1 7.28-12.61c2.02-1.17 3.84-1.28 5.16-.51Z",
    style: {
      fill: "#fff",
      transformOrigin: "67.14px 313.289px"
    },
    id: "els1nv42zikjm",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.5 319.2a16.08 16.08 0 0 1 7.28-12.61c4-2.32 7.28-.44 7.28 4.2a16.1 16.1 0 0 1-7.28 12.61c-4.02 2.32-7.28.44-7.28-4.2Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "70.78px 314.995px"
    },
    id: "el0wsx3mf9ybh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "70.78px 314.995px"
    },
    className: "animable",
    id: "eltdtbunytnmr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5 319.2a16.08 16.08 0 0 1 7.28-12.61c4-2.32 7.28-.44 7.28 4.2a16.1 16.1 0 0 1-7.28 12.61c-4.02 2.32-7.28.44-7.28-4.2Z",
    style: {
      fill: "#fff",
      transformOrigin: "70.78px 314.995px"
    },
    id: "el8bz3v8zkxfl",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "70.78px 314.995px"
    },
    className: "animable",
    id: "eljpqcikvq9fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5 319.2a16.08 16.08 0 0 1 7.28-12.61c4-2.32 7.28-.44 7.28 4.2a16.1 16.1 0 0 1-7.28 12.61c-4.02 2.32-7.28.44-7.28-4.2Z",
    id: "elkus6o21sf49",
    className: "animable",
    style: {
      transformOrigin: "70.78px 314.995px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "70.78px 315.022px"
    },
    className: "animable",
    id: "elb1f9slbonpr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.63 318a11.38 11.38 0 0 1 5.15-8.92c2.84-1.64 5.15-.31 5.15 3a11.4 11.4 0 0 1-5.15 8.92c-2.84 1.58-5.15.25-5.15-3Z",
    id: "el6s7ocumu78h",
    className: "animable",
    style: {
      transformOrigin: "70.78px 315.022px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "68.96px 313.94px"
    },
    className: "animable",
    id: "ell7a2aejoi6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.29 309.92a11.41 11.41 0 0 1-5.15 8.92 5.28 5.28 0 0 1-1.32.53 5.45 5.45 0 0 1-.19-1.4 11.38 11.38 0 0 1 5.15-8.92 5.75 5.75 0 0 1 1.32-.54 5.53 5.53 0 0 1 .19 1.41Z",
    id: "eldbo452rpgsu",
    className: "animable",
    style: {
      transformOrigin: "68.96px 313.94px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m67.14 321.31 11.29 6.51a1.86 1.86 0 0 1 .91 1.59v100.87H93.9V327.49a13.08 13.08 0 0 0-6.53-11.32l-13-7.47a3.61 3.61 0 0 0-3.64.35 11.38 11.38 0 0 0-5.1 8.95 3.6 3.6 0 0 0 1.52 3.33Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "79.7551px 369.322px"
    },
    id: "elf78e8g83t5e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      transformOrigin: "79.7551px 369.322px"
    },
    className: "animable",
    id: "elun745qa40pj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.14 321.31 11.29 6.51a1.86 1.86 0 0 1 .91 1.59v100.87H93.9V327.49a13.08 13.08 0 0 0-6.53-11.32l-13-7.47a3.61 3.61 0 0 0-3.64.35 11.38 11.38 0 0 0-5.1 8.95 3.6 3.6 0 0 0 1.52 3.33Z",
    style: {
      fill: "#fff",
      transformOrigin: "79.7551px 369.322px"
    },
    id: "el7a5kwjz4k36",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "75.1751px 372.395px"
    },
    className: "animable",
    id: "elap04wff70gh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.14 321.31 11.29 6.51a1.86 1.86 0 0 1 .91 1.59v100.87h5.4v-97.65a13.07 13.07 0 0 0-6.53-11.32l-11.79-6.8a9.69 9.69 0 0 0-.79 3.43 3.6 3.6 0 0 0 1.52 3.33Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "75.1751px 372.395px"
    },
    id: "el8242irzuzhl",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.93 422v6c0 1.54-1 3.07-3 4.23a16.06 16.06 0 0 1-14.6 0c-2-1.16-3-2.69-3-4.21v-6h3.07a2.89 2.89 0 0 0 1 2.1 2.61 2.61 0 0 0 .24.23 6.62 6.62 0 0 0 .89.65 11.38 11.38 0 0 0 10.32 0 6.62 6.62 0 0 0 .89-.65 1.75 1.75 0 0 0 .24-.23 3 3 0 0 0 1-2.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "86.63px 427.992px"
    },
    id: "elcogg1wmdtc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "86.63px 427.992px"
    },
    className: "animable",
    id: "el7lznysylx3t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.93 422v6c0 1.54-1 3.07-3 4.23a16.06 16.06 0 0 1-14.6 0c-2-1.16-3-2.69-3-4.21v-6h3.07a2.89 2.89 0 0 0 1 2.1 2.61 2.61 0 0 0 .24.23 6.62 6.62 0 0 0 .89.65 11.38 11.38 0 0 0 10.32 0 6.62 6.62 0 0 0 .89-.65 1.75 1.75 0 0 0 .24-.23 3 3 0 0 0 1-2.1Z",
    style: {
      fill: "#fff",
      transformOrigin: "86.63px 427.992px"
    },
    id: "el5bamh96w8oi",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.93 422c0 1.52-1 3.06-3 4.22a16.18 16.18 0 0 1-14.6 0c-2-1.16-3-2.7-3-4.22s1-3.06 3-4.22V422a2.89 2.89 0 0 0 1 2.1 2.61 2.61 0 0 0 .24.23 6.62 6.62 0 0 0 .89.65 11.38 11.38 0 0 0 10.32 0 6.62 6.62 0 0 0 .89-.65 1.75 1.75 0 0 0 .24-.23 3 3 0 0 0 1-2.1v-4.22c2.01 1.22 3.02 2.71 3.02 4.22Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "86.63px 422.87px"
    },
    id: "el1hjrozhoetw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "86.63px 422.87px"
    },
    className: "animable",
    id: "elcb2w5o8czbb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.93 422c0 1.52-1 3.06-3 4.22a16.18 16.18 0 0 1-14.6 0c-2-1.16-3-2.7-3-4.22s1-3.06 3-4.22V422a2.89 2.89 0 0 0 1 2.1 2.61 2.61 0 0 0 .24.23 6.62 6.62 0 0 0 .89.65 11.38 11.38 0 0 0 10.32 0 6.62 6.62 0 0 0 .89-.65 1.75 1.75 0 0 0 .24-.23 3 3 0 0 0 1-2.1v-4.22c2.01 1.22 3.02 2.71 3.02 4.22Z",
    style: {
      fill: "#fff",
      transformOrigin: "86.63px 422.87px"
    },
    id: "elj6025tlcmn",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "86.63px 422.87px"
    },
    className: "animable",
    id: "elolb05xohxt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.93 422c0 1.52-1 3.06-3 4.22a16.18 16.18 0 0 1-14.6 0c-2-1.16-3-2.7-3-4.22s1-3.06 3-4.22V422a2.89 2.89 0 0 0 1 2.1 2.61 2.61 0 0 0 .24.23 6.62 6.62 0 0 0 .89.65 11.38 11.38 0 0 0 10.32 0 6.62 6.62 0 0 0 .89-.65 1.75 1.75 0 0 0 .24-.23 3 3 0 0 0 1-2.1v-4.22c2.01 1.22 3.02 2.71 3.02 4.22Z",
    id: "elvvorymdqum",
    className: "animable",
    style: {
      transformOrigin: "86.63px 422.87px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--drain--inject-2",
    className: "animable",
    style: {
      transformOrigin: "56.83px 381.492px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "65.625px 440.78px"
    },
    className: "animable",
    id: "elxssd5rv6kf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.7 435.52c-5-2.9-13.14-2.9-18.16 0-2.51 1.44-3.76 3.36-3.76 5.27s1.25 3.8 3.77 5.25c5 2.9 13.13 2.9 18.15 0 2.52-1.45 3.77-3.36 3.77-5.27s-1.25-3.77-3.77-5.25Z",
    id: "elw9z3a92xck",
    className: "animable",
    style: {
      transformOrigin: "65.625px 440.78px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "51.355px 377.079px"
    },
    className: "animable",
    id: "elusz9dzb2lag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.43 343.89a13.06 13.06 0 0 0-6.54-11.32l-6-3.49c0-2.32-.82-3.95-2.14-4.71l-5.13-3c-1.32-.77-3.14-.66-5.16.5a16.11 16.11 0 0 0-7.27 12.61c0 2.32.81 3.95 2.13 4.71l5.14 3c1.32.76 3.13.65 5.14-.5l4.4 2.53a1.83 1.83 0 0 1 .92 1.59v84.1a5.61 5.61 0 0 0-2.89 3.37l17.49-10.1v-74.64Z",
    id: "elfzu0koiemff",
    className: "animable",
    style: {
      transformOrigin: "51.355px 377.079px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m49.77 315.26 5.14 3-10.3 17.83-5.14-3c-1.32-.76-2.13-2.39-2.13-4.71a16.08 16.08 0 0 1 7.28-12.61c2.01-1.17 3.83-1.28 5.15-.51Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "46.125px 325.429px"
    },
    id: "el3bs0fib92hl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "46.125px 325.429px"
    },
    className: "animable",
    id: "elrsqqjicosx8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.77 315.26 5.14 3-10.3 17.83-5.14-3c-1.32-.76-2.13-2.39-2.13-4.71a16.08 16.08 0 0 1 7.28-12.61c2.01-1.17 3.83-1.28 5.15-.51Z",
    style: {
      fill: "#fff",
      transformOrigin: "46.125px 325.429px"
    },
    id: "elkrmnokecxp",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.48 331.34a16.1 16.1 0 0 1 7.28-12.61c4-2.32 7.28-.44 7.28 4.2a16.1 16.1 0 0 1-7.28 12.61c-4.02 2.32-7.28.46-7.28-4.2Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "49.76px 327.137px"
    },
    id: "eltnfq0899eka",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "49.76px 327.137px"
    },
    className: "animable",
    id: "elwt4i0jyfk4g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.48 331.34a16.1 16.1 0 0 1 7.28-12.61c4-2.32 7.28-.44 7.28 4.2a16.1 16.1 0 0 1-7.28 12.61c-4.02 2.32-7.28.46-7.28-4.2Z",
    style: {
      fill: "#fff",
      transformOrigin: "49.76px 327.137px"
    },
    id: "el5m8h8hbxxy2",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "49.76px 327.137px"
    },
    className: "animable",
    id: "elropxjj37x7r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.48 331.34a16.1 16.1 0 0 1 7.28-12.61c4-2.32 7.28-.44 7.28 4.2a16.1 16.1 0 0 1-7.28 12.61c-4.02 2.32-7.28.46-7.28-4.2Z",
    id: "eloxv8awcklx8",
    className: "animable",
    style: {
      transformOrigin: "49.76px 327.137px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "49.765px 327.141px"
    },
    className: "animable",
    id: "elnxilvmcrqr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.62 330.11a11.37 11.37 0 0 1 5.14-8.92c2.84-1.64 5.15-.31 5.15 3a11.4 11.4 0 0 1-5.15 8.92c-2.84 1.61-5.14.28-5.14-3Z",
    id: "elvnkbj228ffm",
    className: "animable",
    style: {
      transformOrigin: "49.765px 327.141px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "47.9449px 326.1px"
    },
    className: "animable",
    id: "eltsoeoljq1vm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.27 322.06a11.37 11.37 0 0 1-5.15 8.94 5.38 5.38 0 0 1-1.31.53 5 5 0 0 1-.19-1.4 11.37 11.37 0 0 1 5.14-8.92 5.93 5.93 0 0 1 1.32-.54 5.53 5.53 0 0 1 .19 1.39Z",
    id: "elihks155cvrg",
    className: "animable",
    style: {
      transformOrigin: "47.9449px 326.1px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.12 333.45 57.41 340a1.84 1.84 0 0 1 .92 1.59v100.15h14.56V339.63a13.08 13.08 0 0 0-6.53-11.32l-12.94-7.47a3.63 3.63 0 0 0-3.65.35 11.37 11.37 0 0 0-5.14 8.92 3.6 3.6 0 0 0 1.51 3.33Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "58.7497px 381.122px"
    },
    id: "eltndy4riaq3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      transformOrigin: "58.7497px 381.122px"
    },
    className: "animable",
    id: "eluwfarra2uym"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.12 333.45 57.41 340a1.84 1.84 0 0 1 .92 1.59v100.15h14.56V339.63a13.08 13.08 0 0 0-6.53-11.32l-12.94-7.47a3.63 3.63 0 0 0-3.65.35 11.37 11.37 0 0 0-5.14 8.92 3.6 3.6 0 0 0 1.51 3.33Z",
    style: {
      fill: "#fff",
      transformOrigin: "58.7497px 381.122px"
    },
    id: "ellj6s8798w7k",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "54.1597px 384.21px"
    },
    className: "animable",
    id: "elwe0lbtdkryi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.12 333.45 57.41 340a1.84 1.84 0 0 1 .92 1.59v100.15h5.39V344.8a13.07 13.07 0 0 0-6.53-11.32l-11.78-6.8a9.47 9.47 0 0 0-.79 3.43 3.6 3.6 0 0 0 1.51 3.33Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "54.1597px 384.21px"
    },
    id: "ell5u96ozwbab",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.91 434.15v6c0 1.53-1 3.06-3 4.22a16 16 0 0 1-14.59 0c-2-1.16-3-2.69-3-4.21v-6h3.06a2.89 2.89 0 0 0 1 2.1 2.73 2.73 0 0 0 .25.23 6 6 0 0 0 .89.65 11.36 11.36 0 0 0 10.31 0 6.62 6.62 0 0 0 .89-.65 2.73 2.73 0 0 0 .25-.23 3 3 0 0 0 1-2.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "65.615px 440.14px"
    },
    id: "elpbipy4iialc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "65.615px 440.14px"
    },
    className: "animable",
    id: "eljhbo2sbpox"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.91 434.15v6c0 1.53-1 3.06-3 4.22a16 16 0 0 1-14.59 0c-2-1.16-3-2.69-3-4.21v-6h3.06a2.89 2.89 0 0 0 1 2.1 2.73 2.73 0 0 0 .25.23 6 6 0 0 0 .89.65 11.36 11.36 0 0 0 10.31 0 6.62 6.62 0 0 0 .89-.65 2.73 2.73 0 0 0 .25-.23 3 3 0 0 0 1-2.1Z",
    style: {
      fill: "#fff",
      transformOrigin: "65.615px 440.14px"
    },
    id: "ell4sw7vfjl7e",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.91 434.15c0 1.52-1 3.06-3 4.22a16.16 16.16 0 0 1-14.59 0c-2-1.16-3-2.7-3-4.22s1-3.06 3-4.22v4.24a2.89 2.89 0 0 0 1 2.1 2.73 2.73 0 0 0 .25.23 6 6 0 0 0 .89.65 11.36 11.36 0 0 0 10.31 0 6.62 6.62 0 0 0 .89-.65 2.73 2.73 0 0 0 .25-.23 3 3 0 0 0 1-2.1v-4.22c2 1.14 3 2.68 3 4.2Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "65.615px 435.02px"
    },
    id: "elx3vyeqrkpy8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "65.615px 435.02px"
    },
    className: "animable",
    id: "el8rp8bkudprc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.91 434.15c0 1.52-1 3.06-3 4.22a16.16 16.16 0 0 1-14.59 0c-2-1.16-3-2.7-3-4.22s1-3.06 3-4.22v4.24a2.89 2.89 0 0 0 1 2.1 2.73 2.73 0 0 0 .25.23 6 6 0 0 0 .89.65 11.36 11.36 0 0 0 10.31 0 6.62 6.62 0 0 0 .89-.65 2.73 2.73 0 0 0 .25-.23 3 3 0 0 0 1-2.1v-4.22c2 1.14 3 2.68 3 4.2Z",
    style: {
      fill: "#fff",
      transformOrigin: "65.615px 435.02px"
    },
    id: "el25w3ts5j19j",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "65.615px 435.02px"
    },
    className: "animable",
    id: "eleofu3sm8kp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.91 434.15c0 1.52-1 3.06-3 4.22a16.16 16.16 0 0 1-14.59 0c-2-1.16-3-2.7-3-4.22s1-3.06 3-4.22v4.24a2.89 2.89 0 0 0 1 2.1 2.73 2.73 0 0 0 .25.23 6 6 0 0 0 .89.65 11.36 11.36 0 0 0 10.31 0 6.62 6.62 0 0 0 .89-.65 2.73 2.73 0 0 0 .25-.23 3 3 0 0 0 1-2.1v-4.22c2 1.14 3 2.68 3 4.2Z",
    id: "eliwi6ou0k97",
    className: "animable",
    style: {
      transformOrigin: "65.615px 435.02px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pipes--inject-2",
    className: "animable",
    style: {
      transformOrigin: "200.284px 200.071px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "236.665px 188.164px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "233.85px 191.253px"
    },
    className: "animable",
    id: "el8aa4dek5n3a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m257.17 326-5.39-3.11c-1.38-.81-3.3-.7-5.41.52l-.21.15-3.69-2.14a1.87 1.87 0 0 1-.94-1.63V247c2.08-1.19 3.12-2.78 3.12-4.36v-6.13c0-1.57-1-3.15-3.12-4.35V152c2.08-1.2 3.12-2.78 3.12-4.36v-6.13c0-1.57-1-3.15-3.12-4.35V61.19a13.46 13.46 0 0 0-6.74-11.67l-6.17-3.61c0-2.4-.84-4.08-2.21-4.86l-5.3-3.05c-1.36-.79-3.24-.68-5.31.52a16.6 16.6 0 0 0-7.51 13c0 2.4.84 4.08 2.2 4.86l5.3 3.06c1.36.78 3.23.67 5.3-.52l4.47 2.61a1.89 1.89 0 0 1 .95 1.64v74c-2.08 1.19-3.12 2.78-3.12 4.35v6.14c0 1.57 1 3.15 3.12 4.35v80c-2.08 1.2-3.12 2.78-3.12 4.35v6.15c0 1.56 1 3.15 3.12 4.35v74.75a13.48 13.48 0 0 0 6.74 11.67l5.48 3.17c0 2.43.85 4.15 2.24 4.94l5.4 3.11c1.38.8 3.29.69 5.4-.53a16.89 16.89 0 0 0 7.64-13.24c0-2.28-.86-3.99-2.24-4.73Z",
    id: "elh284dvovwxc",
    className: "animable",
    style: {
      transformOrigin: "233.85px 191.253px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m223.31 31.66 5.3 3.06L218 53.1l-5.32-3.1c-1.36-.79-2.2-2.47-2.2-4.86a16.59 16.59 0 0 1 7.5-13c2.09-1.14 4.02-1.27 5.33-.48Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "219.545px 42.1291px"
    },
    id: "elfrgz4o0co3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "219.545px 42.1291px"
    },
    className: "animable",
    id: "el2eilvsmhagd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m223.31 31.66 5.3 3.06L218 53.1l-5.32-3.1c-1.36-.79-2.2-2.47-2.2-4.86a16.59 16.59 0 0 1 7.5-13c2.09-1.14 4.02-1.27 5.33-.48Z",
    style: {
      fill: "#fff",
      transformOrigin: "219.545px 42.1291px"
    },
    id: "elqzbodwxt3ne",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.79 48.24a16.61 16.61 0 0 1 7.51-13c4.15-2.39 7.51-.45 7.51 4.33a16.6 16.6 0 0 1-7.51 13c-4.15 2.43-7.51.43-7.51-4.33Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "223.3px 43.912px"
    },
    id: "elh6uhr3fwrk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "223.3px 43.912px"
    },
    className: "animable",
    id: "eldbavqbg3mrm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.79 48.24a16.61 16.61 0 0 1 7.51-13c4.15-2.39 7.51-.45 7.51 4.33a16.6 16.6 0 0 1-7.51 13c-4.15 2.43-7.51.43-7.51-4.33Z",
    style: {
      fill: "#fff",
      transformOrigin: "223.3px 43.912px"
    },
    id: "elguyzks0axxa",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "223.3px 43.912px"
    },
    className: "animable",
    id: "elfic9vxw2lf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.79 48.24a16.61 16.61 0 0 1 7.51-13c4.15-2.39 7.51-.45 7.51 4.33a16.6 16.6 0 0 1-7.51 13c-4.15 2.43-7.51.43-7.51-4.33Z",
    id: "el7xft9ebvwkg",
    className: "animable",
    style: {
      transformOrigin: "223.3px 43.912px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "223.31px 43.9182px"
    },
    className: "animable",
    id: "elbfv8ueylxbc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218 47a11.74 11.74 0 0 1 5.31-9.19c2.93-1.69 5.31-.32 5.31 3.06A11.74 11.74 0 0 1 223.3 50c-2.93 1.73-5.3.36-5.3-3Z",
    id: "el5ywy77mvwwf",
    className: "animable",
    style: {
      transformOrigin: "223.31px 43.9182px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "221.43px 42.84px"
    },
    className: "animable",
    id: "el42ydacuatpf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.86 38.68a11.74 11.74 0 0 1-5.31 9.19 5.68 5.68 0 0 1-1.36.56A5.42 5.42 0 0 1 218 47a11.74 11.74 0 0 1 5.31-9.19 5.68 5.68 0 0 1 1.36-.56 5.85 5.85 0 0 1 .19 1.43Z",
    id: "ely3eea1vl3o",
    className: "animable",
    style: {
      transformOrigin: "221.43px 42.84px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M248.1 321.37a1.88 1.88 0 0 1-.95-1.63V56.8a13.49 13.49 0 0 0-6.74-11.68l-13.35-7.71a3.72 3.72 0 0 0-3.76.37A11.74 11.74 0 0 0 218 47a3.71 3.71 0 0 0 1.57 3.44l11.64 6.72a1.9 1.9 0 0 1 .94 1.64v262.92a13.5 13.5 0 0 0 6.73 11.67l13.36 7.71 7.51-13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "238.864px 189.082px"
    },
    id: "elujuoxeshbdk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      transformOrigin: "238.864px 189.082px"
    },
    className: "animable",
    id: "eliro7dvs1d3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.1 321.37a1.88 1.88 0 0 1-.95-1.63V56.8a13.49 13.49 0 0 0-6.74-11.68l-13.35-7.71a3.72 3.72 0 0 0-3.76.37A11.74 11.74 0 0 0 218 47a3.71 3.71 0 0 0 1.57 3.44l11.64 6.72a1.9 1.9 0 0 1 .94 1.64v262.92a13.5 13.5 0 0 0 6.73 11.67l13.36 7.71 7.51-13Z",
    style: {
      fill: "#fff",
      transformOrigin: "238.864px 189.082px"
    },
    id: "el0jvl4otwyts",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "234.139px 190.895px"
    },
    className: "animable",
    id: "eltfkanvcjgt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.7 325.07V62.13a13.49 13.49 0 0 0-6.7-11.68l-12.15-7A9.83 9.83 0 0 0 218 47a3.71 3.71 0 0 0 1.57 3.44l11.64 6.72a1.9 1.9 0 0 1 .94 1.64v262.92a13.5 13.5 0 0 0 6.73 11.67l8.58 4.95 2.84-4.92-11.64-6.72a1.88 1.88 0 0 1-.96-1.63Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "234.139px 190.895px"
    },
    id: "elzedu1af1e9l",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m257.41 322.84 5.39 3.16-10.8 18.66-5.4-3.11c-1.38-.79-2.23-2.51-2.23-4.94a16.91 16.91 0 0 1 7.63-13.25c2.11-1.22 4-1.36 5.41-.52Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "253.585px 333.484px"
    },
    id: "el49e9v5bzdmv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "253.585px 333.484px"
    },
    className: "animable",
    id: "el0we9xku6eo1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m257.41 322.84 5.39 3.16-10.8 18.66-5.4-3.11c-1.38-.79-2.23-2.51-2.23-4.94a16.91 16.91 0 0 1 7.63-13.25c2.11-1.22 4-1.36 5.41-.52Z",
    style: {
      fill: "#fff",
      transformOrigin: "253.585px 333.484px"
    },
    id: "ele36vvf3dnbv",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.76 339.72a16.91 16.91 0 0 1 7.64-13.24c4.22-2.43 7.64-.46 7.64 4.41a16.89 16.89 0 0 1-7.64 13.24c-4.22 2.43-7.64.46-7.64-4.41Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "257.4px 335.305px"
    },
    id: "elkcl087f9nbq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "257.4px 335.305px"
    },
    className: "animable",
    id: "eltxpy5ryslc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.76 339.72a16.91 16.91 0 0 1 7.64-13.24c4.22-2.43 7.64-.46 7.64 4.41a16.89 16.89 0 0 1-7.64 13.24c-4.22 2.43-7.64.46-7.64-4.41Z",
    style: {
      fill: "#fff",
      transformOrigin: "257.4px 335.305px"
    },
    id: "elralsendmil9",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "257.4px 335.305px"
    },
    className: "animable",
    id: "elhvpr7wxhi5l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.76 339.72a16.91 16.91 0 0 1 7.64-13.24c4.22-2.43 7.64-.46 7.64 4.41a16.89 16.89 0 0 1-7.64 13.24c-4.22 2.43-7.64.46-7.64-4.41Z",
    id: "eln5th1b7keg",
    className: "animable",
    style: {
      transformOrigin: "257.4px 335.305px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "257.4px 335.307px"
    },
    className: "animable",
    id: "elvz1zrw0yr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252 338.43a11.92 11.92 0 0 1 5.4-9.36c3-1.72 5.4-.33 5.4 3.12a11.94 11.94 0 0 1-5.4 9.35c-2.99 1.73-5.4.33-5.4-3.11Z",
    id: "el4m2hff5y5mp",
    className: "animable",
    style: {
      transformOrigin: "257.4px 335.307px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "255.51px 334.22px"
    },
    className: "animable",
    id: "eljc53febeefr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259 330a11.94 11.94 0 0 1-5.4 9.36 5.56 5.56 0 0 1-1.38.56 5.5 5.5 0 0 1-.2-1.47 11.92 11.92 0 0 1 5.4-9.36 5.61 5.61 0 0 1 1.38-.57 5.63 5.63 0 0 1 .2 1.48Z",
    id: "elrl1wgiu8ga",
    className: "animable",
    style: {
      transformOrigin: "255.51px 334.22px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 141.55v6.13c0 1.58-1 3.16-3.12 4.36a16.59 16.59 0 0 1-15.06 0c-2.09-1.2-3.12-2.78-3.12-4.35v-6.14h3.16a3 3 0 0 0 1 2.16l.25.24a6.25 6.25 0 0 0 .92.67 11.74 11.74 0 0 0 10.64 0 6.25 6.25 0 0 0 .92-.67l.25-.24a3 3 0 0 0 1-2.16Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "239.62px 147.699px"
    },
    id: "el78fp6ozoc5x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "239.62px 147.699px"
    },
    className: "animable",
    id: "elpazkvd0ikc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.27 141.55v6.13c0 1.58-1 3.16-3.12 4.36a16.59 16.59 0 0 1-15.06 0c-2.09-1.2-3.12-2.78-3.12-4.35v-6.14h3.16a3 3 0 0 0 1 2.16l.25.24a6.25 6.25 0 0 0 .92.67 11.74 11.74 0 0 0 10.64 0 6.25 6.25 0 0 0 .92-.67l.25-.24a3 3 0 0 0 1-2.16Z",
    style: {
      fill: "#fff",
      transformOrigin: "239.62px 147.699px"
    },
    id: "elchkwxmshxg7",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 141.55c0 1.57-1 3.15-3.12 4.35a16.71 16.71 0 0 1-15.06 0c-2.09-1.2-3.12-2.78-3.12-4.35s1-3.16 3.12-4.35v4.38a3 3 0 0 0 1 2.16l.25.24a6.25 6.25 0 0 0 .92.67 11.74 11.74 0 0 0 10.64 0 6.25 6.25 0 0 0 .92-.67l.25-.24a3 3 0 0 0 1-2.16v-4.38c2.17 1.19 3.2 2.8 3.2 4.35Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "239.62px 142.446px"
    },
    id: "el1gat0w2njzf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "239.62px 142.446px"
    },
    className: "animable",
    id: "elai4gbzmopks"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.27 141.55c0 1.57-1 3.15-3.12 4.35a16.71 16.71 0 0 1-15.06 0c-2.09-1.2-3.12-2.78-3.12-4.35s1-3.16 3.12-4.35v4.38a3 3 0 0 0 1 2.16l.25.24a6.25 6.25 0 0 0 .92.67 11.74 11.74 0 0 0 10.64 0 6.25 6.25 0 0 0 .92-.67l.25-.24a3 3 0 0 0 1-2.16v-4.38c2.17 1.19 3.2 2.8 3.2 4.35Z",
    style: {
      fill: "#fff",
      transformOrigin: "239.62px 142.446px"
    },
    id: "el7rfbc5myxju",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "239.62px 142.446px"
    },
    className: "animable",
    id: "elc3itum3o8ha"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.27 141.55c0 1.57-1 3.15-3.12 4.35a16.71 16.71 0 0 1-15.06 0c-2.09-1.2-3.12-2.78-3.12-4.35s1-3.16 3.12-4.35v4.38a3 3 0 0 0 1 2.16l.25.24a6.25 6.25 0 0 0 .92.67 11.74 11.74 0 0 0 10.64 0 6.25 6.25 0 0 0 .92-.67l.25-.24a3 3 0 0 0 1-2.16v-4.38c2.17 1.19 3.2 2.8 3.2 4.35Z",
    id: "elx80f5k5gg1",
    className: "animable",
    style: {
      transformOrigin: "239.62px 142.446px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 236.46v6.13c0 1.59-1 3.17-3.12 4.36a16.59 16.59 0 0 1-15.06 0c-2.09-1.19-3.12-2.77-3.12-4.34v-6.15h3.16a3 3 0 0 0 1 2.17l.25.24a7.05 7.05 0 0 0 .92.66 11.68 11.68 0 0 0 10.64 0 7.05 7.05 0 0 0 .92-.66l.25-.24a3.07 3.07 0 0 0 1-2.17Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "239.62px 242.609px"
    },
    id: "elng2ptxh2jjb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "239.62px 242.609px"
    },
    className: "animable",
    id: "els9tcgzumrsi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.27 236.46v6.13c0 1.59-1 3.17-3.12 4.36a16.59 16.59 0 0 1-15.06 0c-2.09-1.19-3.12-2.77-3.12-4.34v-6.15h3.16a3 3 0 0 0 1 2.17l.25.24a7.05 7.05 0 0 0 .92.66 11.68 11.68 0 0 0 10.64 0 7.05 7.05 0 0 0 .92-.66l.25-.24a3.07 3.07 0 0 0 1-2.17Z",
    style: {
      fill: "#fff",
      transformOrigin: "239.62px 242.609px"
    },
    id: "el1y0vu0js8t1",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.27 236.46c0 1.57-1 3.15-3.12 4.35a16.71 16.71 0 0 1-15.06 0c-2.09-1.2-3.09-2.81-3.09-4.35s1-3.15 3.12-4.35v4.38a3 3 0 0 0 1 2.17l.25.24a7.05 7.05 0 0 0 .92.66 11.68 11.68 0 0 0 10.64 0 7.05 7.05 0 0 0 .92-.66l.25-.24a3.07 3.07 0 0 0 1-2.17v-4.35c2.14 1.17 3.17 2.75 3.17 4.32Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "239.635px 237.356px"
    },
    id: "elr6w52vbo41k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "239.635px 237.356px"
    },
    className: "animable",
    id: "elunlhdilgkfo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.27 236.46c0 1.57-1 3.15-3.12 4.35a16.71 16.71 0 0 1-15.06 0c-2.09-1.2-3.09-2.81-3.09-4.35s1-3.15 3.12-4.35v4.38a3 3 0 0 0 1 2.17l.25.24a7.05 7.05 0 0 0 .92.66 11.68 11.68 0 0 0 10.64 0 7.05 7.05 0 0 0 .92-.66l.25-.24a3.07 3.07 0 0 0 1-2.17v-4.35c2.14 1.17 3.17 2.75 3.17 4.32Z",
    style: {
      fill: "#fff",
      transformOrigin: "239.635px 237.356px"
    },
    id: "elbau7quapijw",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "239.635px 237.356px"
    },
    className: "animable",
    id: "eldn8h18nlhxp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.27 236.46c0 1.57-1 3.15-3.12 4.35a16.71 16.71 0 0 1-15.06 0c-2.09-1.2-3.09-2.81-3.09-4.35s1-3.15 3.12-4.35v4.38a3 3 0 0 0 1 2.17l.25.24a7.05 7.05 0 0 0 .92.66 11.68 11.68 0 0 0 10.64 0 7.05 7.05 0 0 0 .92-.66l.25-.24a3.07 3.07 0 0 0 1-2.17v-4.35c2.14 1.17 3.17 2.75 3.17 4.32Z",
    id: "elxh8tpra5w3",
    className: "animable",
    style: {
      transformOrigin: "239.635px 237.356px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "212.275px 202.206px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "209.455px 205.292px"
    },
    className: "animable",
    id: "elrxi7u133yp9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m232.78 340-5.38-3.1c-1.38-.81-3.3-.7-5.41.52-.08 0-.14.1-.21.14l-3.69-2.13a1.88 1.88 0 0 1-1-1.63V261c2.09-1.2 3.12-2.78 3.12-4.36v-6.13c0-1.57-1-3.15-3.12-4.35v-80.07c2.09-1.2 3.12-2.78 3.12-4.36v-6.14c0-1.56-1-3.15-3.12-4.34V75.24a13.49 13.49 0 0 0-6.74-11.68L204.23 60c0-2.4-.85-4.08-2.21-4.87L196.73 52c-1.36-.79-3.24-.68-5.32.52a16.6 16.6 0 0 0-7.5 13c0 2.4.84 4.08 2.19 4.86l5.31 3.07c1.36.78 3.23.67 5.3-.52l4.47 2.61a1.9 1.9 0 0 1 .94 1.64v74C200 152.44 199 154 199 155.59v6.15c0 1.57 1 3.15 3.12 4.35v80c-2.09 1.2-3.12 2.78-3.12 4.35v6.14c0 1.57 1 3.16 3.12 4.35v74.75a13.5 13.5 0 0 0 6.73 11.67l5.49 3.17c0 2.43.85 4.14 2.23 4.94l5.41 3.12c1.38.8 3.29.68 5.4-.53a16.89 16.89 0 0 0 7.62-13.11c0-2.44-.83-4.15-2.22-4.94Z",
    id: "el0nv74cvlff2k",
    className: "animable",
    style: {
      transformOrigin: "209.455px 205.292px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m198.93 45.71 5.3 3-10.62 18.44-5.31-3.06c-1.36-.79-2.2-2.47-2.2-4.86a16.63 16.63 0 0 1 7.51-13c2.08-1.23 3.96-1.32 5.32-.52Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "195.165px 56.1707px"
    },
    id: "elx5wismp92b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "195.165px 56.1707px"
    },
    className: "animable",
    id: "elh0av4xzz5s9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m198.93 45.71 5.3 3-10.62 18.44-5.31-3.06c-1.36-.79-2.2-2.47-2.2-4.86a16.63 16.63 0 0 1 7.51-13c2.08-1.23 3.96-1.32 5.32-.52Z",
    style: {
      fill: "#fff",
      transformOrigin: "195.165px 56.1707px"
    },
    id: "elb0kg8x7ibpw",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.41 62.29a16.57 16.57 0 0 1 7.51-13c4.15-2.4 7.51-.46 7.51 4.33a16.63 16.63 0 0 1-7.51 13c-4.15 2.38-7.51.46-7.51-4.33Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "198.92px 57.9506px"
    },
    id: "elaiymu4ksaps",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "198.92px 57.9506px"
    },
    className: "animable",
    id: "elafgmonjgq4g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.41 62.29a16.57 16.57 0 0 1 7.51-13c4.15-2.4 7.51-.46 7.51 4.33a16.63 16.63 0 0 1-7.51 13c-4.15 2.38-7.51.46-7.51-4.33Z",
    style: {
      fill: "#fff",
      transformOrigin: "198.92px 57.9506px"
    },
    id: "eljgsuw1bufoa",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "198.92px 57.9506px"
    },
    className: "animable",
    id: "el9dz04ix3aji"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.41 62.29a16.57 16.57 0 0 1 7.51-13c4.15-2.4 7.51-.46 7.51 4.33a16.63 16.63 0 0 1-7.51 13c-4.15 2.38-7.51.46-7.51-4.33Z",
    id: "el5ldyk7f3wf2",
    className: "animable",
    style: {
      transformOrigin: "198.92px 57.9506px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "198.92px 57.9439px"
    },
    className: "animable",
    id: "elr4reoti885"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.61 61a11.74 11.74 0 0 1 5.31-9.19c2.93-1.7 5.31-.32 5.31 3.06a11.75 11.75 0 0 1-5.31 9.2c-2.92 1.71-5.31.34-5.31-3.07Z",
    id: "elp1yoai1h2m",
    className: "animable",
    style: {
      transformOrigin: "198.92px 57.9439px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "197.04px 56.875px"
    },
    className: "animable",
    id: "elauf752qh27e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.47 52.72a11.73 11.73 0 0 1-5.3 9.2 6 6 0 0 1-1.36.56 5.42 5.42 0 0 1-.2-1.46 11.74 11.74 0 0 1 5.31-9.19 5.3 5.3 0 0 1 1.36-.56 5.85 5.85 0 0 1 .19 1.45Z",
    id: "el4oan6c46fxc",
    className: "animable",
    style: {
      transformOrigin: "197.04px 56.875px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.71 335.42a1.89 1.89 0 0 1-.94-1.63V70.84A13.48 13.48 0 0 0 216 59.17l-13.35-7.71a3.72 3.72 0 0 0-3.76.37 11.74 11.74 0 0 0-5.28 9.17 3.73 3.73 0 0 0 1.56 3.44l11.64 6.72a1.89 1.89 0 0 1 .94 1.63v263a13.48 13.48 0 0 0 6.74 11.67l13.36 7.71 7.51-13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "214.475px 203.142px"
    },
    id: "elbvjazhpjghi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      transformOrigin: "214.475px 203.142px"
    },
    className: "animable",
    id: "el9ar7kco57z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.71 335.42a1.89 1.89 0 0 1-.94-1.63V70.84A13.48 13.48 0 0 0 216 59.17l-13.35-7.71a3.72 3.72 0 0 0-3.76.37 11.74 11.74 0 0 0-5.28 9.17 3.73 3.73 0 0 0 1.56 3.44l11.64 6.72a1.89 1.89 0 0 1 .94 1.63v263a13.48 13.48 0 0 0 6.74 11.67l13.36 7.71 7.51-13Z",
    style: {
      fill: "#fff",
      transformOrigin: "214.475px 203.142px"
    },
    id: "elncssrbqlmj",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "209.745px 205.005px"
    },
    className: "animable",
    id: "elbqjjdwcf3oc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.32 339.12V76.2a13.48 13.48 0 0 0-6.74-11.67l-12.15-7a9.93 9.93 0 0 0-.82 3.54 3.73 3.73 0 0 0 1.56 3.44l11.64 6.72a1.89 1.89 0 0 1 .94 1.63v263a13.48 13.48 0 0 0 6.74 11.67l8.58 4.95 2.83-4.92-11.64-6.72a1.89 1.89 0 0 1-.94-1.72Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "209.745px 205.005px"
    },
    id: "el9zj92xq93jb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m233 336.89 5.39 3.11-10.81 18.71-5.4-3.12c-1.38-.8-2.24-2.51-2.24-4.94a16.89 16.89 0 0 1 7.64-13.24c2.15-1.22 4.06-1.33 5.42-.52Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "229.165px 347.54px"
    },
    id: "el7b6341wppox",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "229.165px 347.54px"
    },
    className: "animable",
    id: "ellqvrjpoya"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m233 336.89 5.39 3.11-10.81 18.71-5.4-3.12c-1.38-.8-2.24-2.51-2.24-4.94a16.89 16.89 0 0 1 7.64-13.24c2.15-1.22 4.06-1.33 5.42-.52Z",
    style: {
      fill: "#fff",
      transformOrigin: "229.165px 347.54px"
    },
    id: "elhgm5tyc6d7e",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.38 353.77a16.89 16.89 0 0 1 7.62-13.24c4.22-2.43 7.64-.46 7.64 4.41a16.93 16.93 0 0 1-7.64 13.24c-4.2 2.43-7.63.46-7.62-4.41Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "233.01px 349.355px"
    },
    id: "elx65yk0tgggh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "233.01px 349.355px"
    },
    className: "animable",
    id: "eliu3y0y2ap8k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.38 353.77a16.89 16.89 0 0 1 7.62-13.24c4.22-2.43 7.64-.46 7.64 4.41a16.93 16.93 0 0 1-7.64 13.24c-4.2 2.43-7.63.46-7.62-4.41Z",
    style: {
      fill: "#fff",
      transformOrigin: "233.01px 349.355px"
    },
    id: "el0g9jf3elf3hj",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "233.01px 349.355px"
    },
    className: "animable",
    id: "elqgam68ge2l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.38 353.77a16.89 16.89 0 0 1 7.62-13.24c4.22-2.43 7.64-.46 7.64 4.41a16.93 16.93 0 0 1-7.64 13.24c-4.2 2.43-7.63.46-7.62-4.41Z",
    id: "elv1zmh3v3hw",
    className: "animable",
    style: {
      transformOrigin: "233.01px 349.355px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "233.015px 349.353px"
    },
    className: "animable",
    id: "eli3vjn2u5t2c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.61 352.47a11.92 11.92 0 0 1 5.41-9.35c3-1.73 5.4-.33 5.4 3.11a11.94 11.94 0 0 1-5.4 9.36c-3.02 1.72-5.41.33-5.41-3.12Z",
    id: "el0rxzpt1wg6xl",
    className: "animable",
    style: {
      transformOrigin: "233.015px 349.353px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "231.105px 348.22px"
    },
    className: "animable",
    id: "elzqfmihjpoud"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.6 344a11.94 11.94 0 0 1-5.41 9.36 5.8 5.8 0 0 1-1.38.56 6 6 0 0 1-.2-1.48 11.92 11.92 0 0 1 5.41-9.35 5.46 5.46 0 0 1 1.38-.57 6 6 0 0 1 .2 1.48Z",
    id: "elw1dbqdu1me",
    className: "animable",
    style: {
      transformOrigin: "231.105px 348.22px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.89 155.59v6.14c0 1.58-1 3.16-3.12 4.36a16.59 16.59 0 0 1-15.06 0c-2.09-1.2-3.13-2.78-3.13-4.35v-6.15h3.17a3 3 0 0 0 1 2.17l.25.24a7.07 7.07 0 0 0 .92.67 11.74 11.74 0 0 0 10.64 0 7.07 7.07 0 0 0 .92-.67l.25-.24a3.05 3.05 0 0 0 1-2.17Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "215.235px 161.744px"
    },
    id: "el9mvopptmfdc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "215.235px 161.744px"
    },
    className: "animable",
    id: "elop6qygzwdwd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.89 155.59v6.14c0 1.58-1 3.16-3.12 4.36a16.59 16.59 0 0 1-15.06 0c-2.09-1.2-3.13-2.78-3.13-4.35v-6.15h3.17a3 3 0 0 0 1 2.17l.25.24a7.07 7.07 0 0 0 .92.67 11.74 11.74 0 0 0 10.64 0 7.07 7.07 0 0 0 .92-.67l.25-.24a3.05 3.05 0 0 0 1-2.17Z",
    style: {
      fill: "#fff",
      transformOrigin: "215.235px 161.744px"
    },
    id: "el5gnwfhgrh6v",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.89 155.59c0 1.57-1 3.16-3.12 4.35a16.65 16.65 0 0 1-15.06 0c-2.09-1.19-3.13-2.78-3.13-4.35s1-3.15 3.13-4.35v4.37a3 3 0 0 0 1 2.17l.25.24a7.07 7.07 0 0 0 .92.67 11.74 11.74 0 0 0 10.64 0 7.07 7.07 0 0 0 .92-.67l.25-.24a3.05 3.05 0 0 0 1-2.17v-4.35c2.16 1.18 3.2 2.74 3.2 4.33Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "215.235px 156.49px"
    },
    id: "eldltirlc7o1f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "215.235px 156.49px"
    },
    className: "animable",
    id: "elwxuzxvwpyoh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.89 155.59c0 1.57-1 3.16-3.12 4.35a16.65 16.65 0 0 1-15.06 0c-2.09-1.19-3.13-2.78-3.13-4.35s1-3.15 3.13-4.35v4.37a3 3 0 0 0 1 2.17l.25.24a7.07 7.07 0 0 0 .92.67 11.74 11.74 0 0 0 10.64 0 7.07 7.07 0 0 0 .92-.67l.25-.24a3.05 3.05 0 0 0 1-2.17v-4.35c2.16 1.18 3.2 2.74 3.2 4.33Z",
    style: {
      fill: "#fff",
      transformOrigin: "215.235px 156.49px"
    },
    id: "elrnlgcoacm79",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "215.235px 156.49px"
    },
    className: "animable",
    id: "el6sjyanl5t2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.89 155.59c0 1.57-1 3.16-3.12 4.35a16.65 16.65 0 0 1-15.06 0c-2.09-1.19-3.13-2.78-3.13-4.35s1-3.15 3.13-4.35v4.37a3 3 0 0 0 1 2.17l.25.24a7.07 7.07 0 0 0 .92.67 11.74 11.74 0 0 0 10.64 0 7.07 7.07 0 0 0 .92-.67l.25-.24a3.05 3.05 0 0 0 1-2.17v-4.35c2.16 1.18 3.2 2.74 3.2 4.33Z",
    id: "el68vevdvsnv5",
    className: "animable",
    style: {
      transformOrigin: "215.235px 156.49px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.89 250.51v6.13c0 1.58-1 3.17-3.12 4.36a16.59 16.59 0 0 1-15.06 0c-2.09-1.19-3.13-2.78-3.13-4.35v-6.14h3.17a3 3 0 0 0 1 2.17l.25.24a7.05 7.05 0 0 0 .92.66 11.74 11.74 0 0 0 10.64 0 7.05 7.05 0 0 0 .92-.66l.25-.24a3.07 3.07 0 0 0 1-2.17Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "215.235px 256.659px"
    },
    id: "elths26z7tkec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "215.235px 256.659px"
    },
    className: "animable",
    id: "elo2fr5x3299"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.89 250.51v6.13c0 1.58-1 3.17-3.12 4.36a16.59 16.59 0 0 1-15.06 0c-2.09-1.19-3.13-2.78-3.13-4.35v-6.14h3.17a3 3 0 0 0 1 2.17l.25.24a7.05 7.05 0 0 0 .92.66 11.74 11.74 0 0 0 10.64 0 7.05 7.05 0 0 0 .92-.66l.25-.24a3.07 3.07 0 0 0 1-2.17Z",
    style: {
      fill: "#fff",
      transformOrigin: "215.235px 256.659px"
    },
    id: "ely47l0ll1y5n",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.89 250.51c0 1.57-1 3.15-3.12 4.35a16.71 16.71 0 0 1-15.06 0c-2.09-1.2-3.13-2.78-3.13-4.35s1-3.15 3.13-4.35v4.38a3 3 0 0 0 1 2.17l.25.24a7.05 7.05 0 0 0 .92.66 11.74 11.74 0 0 0 10.64 0 7.05 7.05 0 0 0 .92-.66l.25-.24a3.07 3.07 0 0 0 1-2.17v-4.35c2.16 1.17 3.2 2.75 3.2 4.32Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "215.235px 251.406px"
    },
    id: "eldg2rskwfnyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "215.235px 251.406px"
    },
    className: "animable",
    id: "el4632pzwn0x5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.89 250.51c0 1.57-1 3.15-3.12 4.35a16.71 16.71 0 0 1-15.06 0c-2.09-1.2-3.13-2.78-3.13-4.35s1-3.15 3.13-4.35v4.38a3 3 0 0 0 1 2.17l.25.24a7.05 7.05 0 0 0 .92.66 11.74 11.74 0 0 0 10.64 0 7.05 7.05 0 0 0 .92-.66l.25-.24a3.07 3.07 0 0 0 1-2.17v-4.35c2.16 1.17 3.2 2.75 3.2 4.32Z",
    style: {
      fill: "#fff",
      transformOrigin: "215.235px 251.406px"
    },
    id: "elae736lruz7e",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "215.235px 251.406px"
    },
    className: "animable",
    id: "elhj1kn9tpiv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.89 250.51c0 1.57-1 3.15-3.12 4.35a16.71 16.71 0 0 1-15.06 0c-2.09-1.2-3.13-2.78-3.13-4.35s1-3.15 3.13-4.35v4.38a3 3 0 0 0 1 2.17l.25.24a7.05 7.05 0 0 0 .92.66 11.74 11.74 0 0 0 10.64 0 7.05 7.05 0 0 0 .92-.66l.25-.24a3.07 3.07 0 0 0 1-2.17v-4.35c2.16 1.17 3.2 2.75 3.2 4.32Z",
    id: "elxy47yfxuhsi",
    className: "animable",
    style: {
      transformOrigin: "215.235px 251.406px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tube--inject-2",
    className: "animable",
    style: {
      transformOrigin: "174.133px 345.585px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.73 325.13a3.46 3.46 0 0 0-1.59-2.73 1.11 1.11 0 0 0-1.12-.11L136 365a1.08 1.08 0 0 0-.46 1 3.51 3.51 0 0 0 1.58 2.73 1.13 1.13 0 0 0 1.12.11l74-42.73a1.13 1.13 0 0 0 .49-.98Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "174.133px 345.563px"
    },
    id: "elx8d18dh40y9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.73 325.13a3.46 3.46 0 0 0-1.59-2.73 1.11 1.11 0 0 0-1.12-.11L136 365a1.08 1.08 0 0 0-.46 1 3.51 3.51 0 0 0 1.58 2.73 1.13 1.13 0 0 0 1.12.11l74-42.73a1.13 1.13 0 0 0 .49-.98Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "174.133px 345.563px"
    },
    className: "animable",
    id: "ell6hjux0ptk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.13 368.77a1.13 1.13 0 0 0 1.12.11l74-42.73a1.13 1.13 0 0 0 .46-1 3 3 0 0 0-.33-1.23l-76.17 44a3.17 3.17 0 0 0 .92.85Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.3,
      transformOrigin: "174.462px 346.45px"
    },
    className: "animable",
    id: "el1hmv35nzt4s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.13 368.77c.88.5 1.59.09 1.59-.91a3.51 3.51 0 0 0-1.59-2.74c-.88-.5-1.59-.09-1.58.92a3.51 3.51 0 0 0 1.58 2.73Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "137.135px 366.945px"
    },
    id: "elpo2idedt8rp",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tube--inject-2",
    className: "animable",
    style: {
      transformOrigin: "185.705px 309.8px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.4 343.32a6.27 6.27 0 0 1-3.17-.82c-2.18-1.26-3.43-3.8-3.43-7v-47.26h5.1v47.29a3 3 0 0 0 .88 2.56c.54.31 1.55.11 2.65-.52l6-3.45a13.7 13.7 0 0 0 6.09-10.55v-47.29h5.09v47.29a18.86 18.86 0 0 1-8.62 15L184 342a9.26 9.26 0 0 1-4.6 1.32Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "185.705px 309.8px"
    },
    id: "elcu4ootm7ysj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      transformOrigin: "185.705px 309.8px"
    },
    className: "animable",
    id: "elq8zpl8hpnf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.4 343.32a6.27 6.27 0 0 1-3.17-.82c-2.18-1.26-3.43-3.8-3.43-7v-47.26h5.1v47.29a3 3 0 0 0 .88 2.56c.54.31 1.55.11 2.65-.52l6-3.45a13.7 13.7 0 0 0 6.09-10.55v-47.29h5.09v47.29a18.86 18.86 0 0 1-8.62 15L184 342a9.26 9.26 0 0 1-4.6 1.32Z",
    style: {
      fill: "#fff",
      transformOrigin: "185.705px 309.8px"
    },
    id: "elopn1h1e8n2",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "185.685px 287.865px"
    },
    className: "animable",
    id: "elms7woj3m23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.8 293.53v3.55l5.1-2.95v-3.55Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "175.35px 293.83px"
    },
    id: "elsno5dlc5z4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.57 278.65-5.09 2.94v3.55l5.09-2.94Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "196.025px 281.895px"
    },
    id: "elt3rr34wslyk",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "185.685px 287.865px"
    },
    className: "animable",
    id: "el7ifn50w99yx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.8 293.53v3.55l5.1-2.95v-3.55Z",
    id: "elf1jli5ny997",
    className: "animable",
    style: {
      transformOrigin: "175.35px 293.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.57 278.65-5.09 2.94v3.55l5.09-2.94Z",
    id: "elw3x0s7t287g",
    className: "animable",
    style: {
      transformOrigin: "196.025px 281.895px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "155.785px 326.666px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176 316.8a3.5 3.5 0 0 0-1.59-2.74 1.1 1.1 0 0 0-1.12-.1L136 335.51a1.09 1.09 0 0 0-.46 1 3.49 3.49 0 0 0 1.58 2.73 1.11 1.11 0 0 0 1.12.11l37.32-21.56a1.1 1.1 0 0 0 .44-.99Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "155.77px 326.652px"
    },
    id: "elpq6595ab0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 316.8a3.5 3.5 0 0 0-1.59-2.74 1.1 1.1 0 0 0-1.12-.1L136 335.51a1.09 1.09 0 0 0-.46 1 3.49 3.49 0 0 0 1.58 2.73 1.11 1.11 0 0 0 1.12.11l37.32-21.56a1.1 1.1 0 0 0 .44-.99Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "155.77px 326.652px"
    },
    className: "animable",
    id: "el4moxy5vqsw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.13 339.26a1.11 1.11 0 0 0 1.12.11l37.32-21.56a1.1 1.1 0 0 0 .46-1 3.17 3.17 0 0 0-.32-1.23l-39.48 22.8a3 3 0 0 0 .9.88Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.3,
      transformOrigin: "156.132px 327.526px"
    },
    className: "animable",
    id: "el4ipqsctmhnd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.13 339.26c.88.51 1.59.1 1.59-.91a3.49 3.49 0 0 0-1.59-2.73c-.88-.51-1.59-.1-1.58.91a3.49 3.49 0 0 0 1.58 2.73Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "137.135px 337.44px"
    },
    id: "elv8e3j1vq4dn",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "174.133px 289.712px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.72 270.4a5.69 5.69 0 0 0-2.6-4.48 1.83 1.83 0 0 0-1.83-.18l-72 41.61a1.78 1.78 0 0 0-.75 1.67 5.73 5.73 0 0 0 2.6 4.48 1.82 1.82 0 0 0 1.83.18l72-41.61a1.84 1.84 0 0 0 .75-1.67Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "174.128px 289.711px"
    },
    id: "elikgxf0xswy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.72 270.4a5.69 5.69 0 0 0-2.6-4.48 1.83 1.83 0 0 0-1.83-.18l-72 41.61a1.78 1.78 0 0 0-.75 1.67 5.73 5.73 0 0 0 2.6 4.48 1.82 1.82 0 0 0 1.83.18l72-41.61a1.84 1.84 0 0 0 .75-1.67Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "174.128px 289.711px"
    },
    className: "animable",
    id: "elwltm5p07fea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.15 313.5a1.82 1.82 0 0 0 1.83.18l72-41.61a1.84 1.84 0 0 0 .75-1.67 4.9 4.9 0 0 0-.53-2L136.67 312a5 5 0 0 0 1.48 1.5Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.3,
      transformOrigin: "174.704px 291.123px"
    },
    className: "animable",
    id: "el3xo6dniynp3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.15 313.5c1.43.82 2.59.15 2.59-1.5a5.73 5.73 0 0 0-2.6-4.48c-1.44-.82-2.6-.15-2.59 1.5a5.73 5.73 0 0 0 2.6 4.48Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "138.145px 310.51px"
    },
    id: "eluzhqz1acn3l",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Valve--inject-2",
    className: "animable",
    style: {
      transformOrigin: "187.52px 338.806px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.84 341.76a15.21 15.21 0 0 1 6.93-11.94c1.91-1.09 3.63-1.19 4.88-.47l3.54 2c1.25.72 2 2.26 2 4.45a15.3 15.3 0 0 1-6.94 11.94c-1.9 1.1-3.62 1.2-4.87.48l-3.56-2.06c-1.22-.68-1.98-2.16-1.98-4.4Z",
    style: {
      fill: "#37474f",
      transformOrigin: "187.515px 338.785px"
    },
    id: "el506bcg65hqr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.26 347.78c-3.81 2.2-6.9.42-6.9-4a15.21 15.21 0 0 1 6.93-11.94c3.83-2.19 6.92-.41 6.91 4a15.3 15.3 0 0 1-6.94 11.94Z",
    style: {
      fill: "#455a64",
      transformOrigin: "189.28px 339.813px"
    },
    id: "elwx5q74b2a9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.27 346.1c-3 1.74-5.45.33-5.45-3.14a12 12 0 0 1 5.47-9.42c3-1.73 5.46-.33 5.45 3.14a12.05 12.05 0 0 1-5.47 9.42Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "189.28px 339.822px"
    },
    id: "elvthsu3glztj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "189.275px 337.1px"
    },
    id: "elsng81xnggqr",
    className: "animable",
    d: "m189.7 339.8-.42-5.4-.43 5.4h.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.28 340.87c-.5.29-.91.05-.91-.52a2 2 0 0 1 .91-1.57c.5-.29.91-.06.91.52a2 2 0 0 1-.91 1.57Z",
    style: {
      fill: "#455a64",
      transformOrigin: "189.28px 339.824px"
    },
    id: "elnws54rd189",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "176.973px 208.295px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.73 190a4.49 4.49 0 0 0-2.06-3.54 1.45 1.45 0 0 0-1.44-.14l-67.41 38.93a1.44 1.44 0 0 0-.6 1.32 4.56 4.56 0 0 0 2.05 3.53 1.4 1.4 0 0 0 1.44.14l67.43-38.93a1.45 1.45 0 0 0 .59-1.31Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "176.975px 208.284px"
    },
    id: "elqu6jo495cee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.73 190a4.49 4.49 0 0 0-2.06-3.54 1.45 1.45 0 0 0-1.44-.14l-67.41 38.93a1.44 1.44 0 0 0-.6 1.32 4.56 4.56 0 0 0 2.05 3.53 1.4 1.4 0 0 0 1.44.14l67.43-38.93a1.45 1.45 0 0 0 .59-1.31Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "176.975px 208.284px"
    },
    className: "animable",
    id: "el5qgr1jxaq7n"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.27 230.12a1.4 1.4 0 0 0 1.44.14l67.43-38.93a1.45 1.45 0 0 0 .59-1.31 3.93 3.93 0 0 0-.42-1.59L142.1 229a4 4 0 0 0 1.17 1.12Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.3,
      transformOrigin: "177.418px 209.414px"
    },
    className: "animable",
    id: "elm15bkpalvhh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.27 230.12c1.13.65 2 .13 2-1.18a4.49 4.49 0 0 0-2.06-3.53c-1.13-.65-2-.12-2 1.18a4.56 4.56 0 0 0 2.06 3.53Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "143.24px 227.766px"
    },
    id: "elzq0d97i5gfd",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M174.67 226.46a7.43 7.43 0 0 1-3.73-1c-2.66-1.54-4.13-4.7-4.13-8.9 0-8.23 5.8-18.28 12.93-22.4 3.64-2.1 7.11-2.41 9.78-.87s4.13 4.7 4.13 8.9c0 8.23-5.81 18.28-12.94 22.4a12.24 12.24 0 0 1-6.04 1.87Zm6-30.58c-6.59 3.81-12 13.1-12 20.72 0 3.48 1.12 6 3.16 7.22s4.82.87 7.83-.87c6.6-3.81 12-13.11 12-20.72 0-3.48-1.12-6-3.16-7.22s-4.82-.87-7.84.87Z",
    style: {
      fill: "#455a64",
      transformOrigin: "180.23px 209.392px"
    },
    id: "elybn4w3owdwg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "184.63px 211.95px",
      transform: "rotate(-60deg)"
    },
    className: "animable",
    d: "M183.66 206.87h1.94v10.16h-1.94z",
    id: "el68zjp7ug3j3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "186.455px 205.82px",
      transform: "rotate(-30deg)"
    },
    className: "animable",
    d: "M179.27 204.85h14.37v1.94h-14.37z",
    id: "elb2ozwf4rv6a"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "180.23px 202.225px"
    },
    id: "elcwx414jjat",
    className: "animable",
    d: "M179.26 195.04h1.94v14.37h-1.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "175.83px 206.87px",
      transform: "rotate(-60deg)"
    },
    className: "animable",
    d: "M174.86 201.79h1.94v10.16h-1.94z",
    id: "elz2k2atm683"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "174.005px 213.01px",
      transform: "rotate(-29.8865deg)"
    },
    className: "animable",
    d: "M166.82 212.04h14.37v1.94h-14.37z",
    id: "elqqsvksjr3j"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "180.23px 216.595px"
    },
    id: "elatve3f3thzq",
    className: "animable",
    d: "M179.26 209.41h1.94v14.37h-1.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.23 205.69a2 2 0 0 1 3.23 1.86 7.14 7.14 0 0 1-3.23 5.59 2 2 0 0 1-3.23-1.86 7.14 7.14 0 0 1 3.23-5.59Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "180.23px 209.415px"
    },
    id: "ela0x942wslcf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.23 205.69a2 2 0 0 1 3.23 1.86 7.14 7.14 0 0 1-3.23 5.59 2 2 0 0 1-3.23-1.86 7.14 7.14 0 0 1 3.23-5.59Z",
    style: {
      opacity: 0.2,
      transformOrigin: "180.23px 209.415px"
    },
    className: "animable",
    id: "el7c5w6mxnahp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.44 206.38a2 2 0 0 1 3.23 1.87 7.14 7.14 0 0 1-3.23 5.59 2.31 2.31 0 0 1-2.29.23 2.28 2.28 0 0 1-.94-2.09 7.13 7.13 0 0 1 3.23-5.6Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "181.446px 210.105px"
    },
    id: "elenz5s2juyik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Faucet--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250.636px 220.007px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.72 209.71a2.94 2.94 0 0 0-3 .29 9.29 9.29 0 0 0-4.21 7.29 2.94 2.94 0 0 0 1.24 2.73l.93.53a2.94 2.94 0 0 0 3-.29 9.32 9.32 0 0 0 4.21-7.29 3 3 0 0 0-1.24-2.72Z",
    style: {
      fill: "#37474f",
      transformOrigin: "244.198px 215.13px"
    },
    id: "elmpcexmcpdl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57 216.64v.65a2.94 2.94 0 0 0 1.24 2.73l.93.53a2.94 2.94 0 0 0 3-.29q.27-.16.54-.36Z",
    style: {
      fill: "#263238",
      transformOrigin: "242.416px 218.736px"
    },
    id: "eljcchmdrxpwi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.47 217.83c0 2.69 1.88 3.77 4.21 2.43a9.32 9.32 0 0 0 4.21-7.29c0-2.69-1.89-3.77-4.21-2.43a9.29 9.29 0 0 0-4.21 7.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "244.68px 215.4px"
    },
    id: "elplse2bqu9zb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.13 220.18a1.18 1.18 0 0 0 1.21-.12 3.78 3.78 0 0 0 1.71-3 1.19 1.19 0 0 0-.5-1.1l-4.55-2.6a1.23 1.23 0 0 0-1.21.12 3.79 3.79 0 0 0-1.71 3 1.19 1.19 0 0 0 .5 1.1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "247.065px 216.774px"
    },
    id: "el0rhe0od81u8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251 216.67-5.82-3.36a1.92 1.92 0 0 0-.4.17 2.47 2.47 0 0 0-.38.28l6.52 3.76h.09a2.58 2.58 0 0 0 0-.39 1.88 1.88 0 0 0-.01-.46Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "247.71px 215.415px"
    },
    className: "animable",
    id: "elmag4ea50g2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.34 220.06a2.88 2.88 0 0 0 .6-.47l-3.57-2.07c-1.3-.75-2.22-1.12-2.4-2.14a1.94 1.94 0 0 1 .94-2l-.13.07a3.79 3.79 0 0 0-1.71 3 1.19 1.19 0 0 0 .5 1.1l4.56 2.63a1.18 1.18 0 0 0 1.21-.12Z",
    style: {
      fill: "#37474f",
      transformOrigin: "246.502px 216.837px"
    },
    id: "elt0njv8jb1pg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.06 221.13a1.39 1.39 0 0 0-.29-.92l-.09-.08-.08-.06c-.61-.35-2.46-2.71-4.22-3.73s-2.22 0-2.81-.33a1.19 1.19 0 0 0-1.21.13 3.75 3.75 0 0 0-1.71 3 1.18 1.18 0 0 0 .5 1.1c.59.34 1.14 1.95 2.79 2.91s3.62.78 4.22 1.13a1.18 1.18 0 0 0 1.21-.12 3.75 3.75 0 0 0 1.71-3Z",
    style: {
      fill: "#455a64",
      transformOrigin: "252.861px 220.133px"
    },
    id: "elhxijlrsr1ck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.88 221.17a.85.85 0 0 0 .88-.19 1.17 1.17 0 0 0-.25-.55.38.38 0 0 0-.09-.09l-.08-.06c-.61-.35-2.41-2.51-4.22-3.72a3.54 3.54 0 0 0-1.46-.64c-.28 0-.5.13-.7.15a4.49 4.49 0 0 1 2.93 2 10.52 10.52 0 0 0 2.99 3.1Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "254.36px 218.57px"
    },
    className: "animable",
    id: "el43dr614zane"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.21 224.1c-.61-.51-1.7-.56-3.24-1.17a5.33 5.33 0 0 1-3.06-3.89c-.23-1.57.1-3 1-3a.64.64 0 0 1-.33-.08 1.19 1.19 0 0 0-1.21.13 3.75 3.75 0 0 0-1.71 3 1.18 1.18 0 0 0 .5 1.1c.59.34 1.14 1.95 2.79 2.91s3.62.78 4.22 1.13a1.14 1.14 0 0 0 1.11-.06.21.21 0 0 0-.07-.07Z",
    style: {
      fill: "#37474f",
      transformOrigin: "251.966px 220.099px"
    },
    id: "elmv0tl3alwpi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 229.49a1.45 1.45 0 0 0 .84 1.18 4.54 4.54 0 0 0 4.08 0 1.45 1.45 0 0 0 .84-1.18v-2.31a1.44 1.44 0 0 0-.84-1.18 4.51 4.51 0 0 0-4.08 0 1.44 1.44 0 0 0-.84 1.18Z",
    style: {
      fill: "#37474f",
      transformOrigin: "258.88px 228.333px"
    },
    id: "el7aak4010r2w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.78 227.18a1.44 1.44 0 0 0-.84-1.18 4.51 4.51 0 0 0-4.08 0 1.24 1.24 0 0 0 0 2.35 4.51 4.51 0 0 0 4.08 0 1.42 1.42 0 0 0 .84-1.17",
    style: {
      fill: "#455a64",
      transformOrigin: "258.898px 227.175px"
    },
    id: "elu0ybii3d2pc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.32 227v-1.48a5.71 5.71 0 0 0-2.87-5l-.86-.5a1.18 1.18 0 0 0-1.24.1 3.78 3.78 0 0 0-1.71 3 1.18 1.18 0 0 0 .5 1.1l.62.36a1.45 1.45 0 0 1 .73 1.25V227a1.19 1.19 0 0 0 .7 1 3.75 3.75 0 0 0 3.42 0 1.21 1.21 0 0 0 .71-1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "257.976px 224.151px"
    },
    id: "elf9onec4z7ih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.06 225.59a5.63 5.63 0 0 0-2.81-4.87l-1.34-.77-.95.54 1.66 1a5 5 0 0 1 2.49 4.32v2.43a2.61 2.61 0 0 0 .51-.22 1.85 1.85 0 0 0 .45-.35Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "258.515px 224.095px"
    },
    className: "animable",
    id: "el4u2157hy31d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.59 220.06a1.17 1.17 0 0 0-1.13.1 3 3 0 0 0-.89.78 4.09 4.09 0 0 0-.62 1 3.5 3.5 0 0 0-.31 1.16 2.9 2.9 0 0 1 .21-1.2 3.91 3.91 0 0 1 .61-1.07 3.16 3.16 0 0 1 1-.79 1.78 1.78 0 0 1 .6-.16.91.91 0 0 1 .53.18Z",
    style: {
      fill: "#37474f",
      transformOrigin: "256.114px 221.49px"
    },
    id: "elnbnqqkbc8a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.76 225.6c0-1.37-.4-1.73-1.14-2.15s-1.66-1.24-1.46-2a3.5 3.5 0 0 0-.52 1.72 1.18 1.18 0 0 0 .5 1.1l.62.36a1.45 1.45 0 0 1 .73 1.25V227a1.19 1.19 0 0 0 .7 1 3.75 3.75 0 0 0 3.42 0 2.51 2.51 0 0 1-2.22-.47 2.22 2.22 0 0 1-.63-1.93Z",
    style: {
      fill: "#37474f",
      transformOrigin: "257.621px 224.931px"
    },
    id: "eltzupilkj9z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.19 228a3.35 3.35 0 0 0 1.15.32 4.24 4.24 0 0 0 1.18 0 3 3 0 0 0 1.12-.37 1.21 1.21 0 0 0 .68-.9.92.92 0 0 1-.18.57 1.54 1.54 0 0 1-.45.43 3.06 3.06 0 0 1-1.14.41 3.9 3.9 0 0 1-1.23 0 2.88 2.88 0 0 1-1.13-.46Z",
    style: {
      fill: "#37474f",
      transformOrigin: "259.255px 227.779px"
    },
    id: "elqfl6q0tgcne",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.7 210a1.14 1.14 0 0 0-1.14-1.14 1.16 1.16 0 0 0-.56.14c-1 .59-2.73 2.14-3.18 2.41a.34.34 0 0 0-.12.29 1 1 0 0 0 .46.79.32.32 0 0 0 .32 0c.51-.26 2.67-1 3.65-1.53a1.15 1.15 0 0 0 .57-.96Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "256.199px 210.696px"
    },
    id: "ellhia91az41",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.56 209.52a.18.18 0 0 0 0 .18c0 .06.12.08.28.08h.64a1.43 1.43 0 0 0 .54-.09c.42-.2.07-.61-.31-.63a1.33 1.33 0 0 0-1.15.46Z",
    style: {
      fill: "#fff",
      opacity: 0.25,
      transformOrigin: "257.373px 209.417px"
    },
    className: "animable",
    id: "elpam1dplrboe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.23 210.92a24.49 24.49 0 0 0-3.31 1.37 1 1 0 0 0 .22.19.32.32 0 0 0 .32 0c.51-.26 2.67-1 3.65-1.53a1.15 1.15 0 0 0 .59-1 1.11 1.11 0 0 0-.18-.6c.16.45-.03 1.19-1.29 1.57Z",
    style: {
      opacity: 0.2,
      transformOrigin: "256.31px 210.936px"
    },
    className: "animable",
    id: "elmpirav8zcx"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.68 211.69a1 1 0 0 0 .46.79c.25.14.45 0 .45-.26a1 1 0 0 0-.45-.79c-.25-.15-.46-.03-.46.26Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "254.135px 211.95px"
    },
    id: "eld0p2kg3ogff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.68 211.69a1 1 0 0 0 .46.79c.25.14.45 0 .45-.26a1 1 0 0 0-.45-.79c-.25-.15-.46-.03-.46.26Z",
    style: {
      opacity: 0.3,
      transformOrigin: "254.135px 211.95px"
    },
    className: "animable",
    id: "el1711adkchsd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.88 218a1.14 1.14 0 0 0 .68 1 3.63 3.63 0 0 0 3.29 0 1.17 1.17 0 0 0 .68-1v-3.4a1.15 1.15 0 0 0-.68-.95 3.6 3.6 0 0 0-3.29 0 1.13 1.13 0 0 0-.68.95Z",
    style: {
      fill: "#37474f",
      transformOrigin: "253.205px 216.323px"
    },
    id: "ellkzki7w2ff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.06 213.43a2.52 2.52 0 0 0-.5.22 1.13 1.13 0 0 0-.68.95v3.4a1.14 1.14 0 0 0 .68 1 2.52 2.52 0 0 0 .5.22Z",
    style: {
      fill: "#263238",
      transformOrigin: "251.47px 216.325px"
    },
    id: "el34ciq6xn3as",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.53 214.6a1.15 1.15 0 0 0-.68-.95 3.6 3.6 0 0 0-3.29 0 1 1 0 0 0 0 1.9 3.66 3.66 0 0 0 3.29 0 1.18 1.18 0 0 0 .68-1",
    style: {
      fill: "#455a64",
      transformOrigin: "253.201px 214.596px"
    },
    id: "el020uvbovxaf1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.68 214.36a.77.77 0 0 0 .44.62 2.38 2.38 0 0 0 2.16 0 .76.76 0 0 0 .45-.62v-2.68a.75.75 0 0 0-.45-.62 2.35 2.35 0 0 0-2.16 0 .75.75 0 0 0-.44.62Z",
    style: {
      fill: "#37474f",
      transformOrigin: "253.205px 213.018px"
    },
    id: "elfwj3yqymqmu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.06 211.1a.73.73 0 0 0-.38.58v2.68a.73.73 0 0 0 .38.58Z",
    style: {
      fill: "#263238",
      transformOrigin: "251.87px 213.02px"
    },
    id: "ela1j5pcj3skp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.73 211.68a.75.75 0 0 0-.45-.62 2.35 2.35 0 0 0-2.16 0 .66.66 0 0 0 0 1.24 2.35 2.35 0 0 0 2.16 0 .75.75 0 0 0 .45-.62",
    style: {
      fill: "#455a64",
      transformOrigin: "253.208px 211.68px"
    },
    id: "els8uk5lyjao8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.52 213.41a1 1 0 0 0-.46-.79.32.32 0 0 0-.32 0c-.51.26-2.67 1-3.65 1.54a1.12 1.12 0 0 0-.58 1 1.14 1.14 0 0 0 1.13 1.14 1.16 1.16 0 0 0 .56-.14c1-.59 2.73-2.14 3.18-2.41a.34.34 0 0 0 .14-.34Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "250.018px 214.439px"
    },
    id: "eltvg0ha2fsaf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.79 214.84a.73.73 0 0 0 .17.59.57.57 0 0 0 .58.17.22.22 0 0 0 .18-.14.23.23 0 0 0 0-.18 1.49 1.49 0 0 0-.12-.14.89.89 0 0 1-.21-.51.78.78 0 0 0 0-.22c-.22-.32-.57.12-.6.43Z",
    style: {
      fill: "#fff",
      opacity: 0.25,
      transformOrigin: "248.26px 214.96px"
    },
    className: "animable",
    id: "elpteq2s3tp9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.39 213.7a.34.34 0 0 0 .12-.29.89.89 0 0 0 0-.22 25 25 0 0 0-2.87 2.15c-1 .87-1.69.66-2 .32a1.11 1.11 0 0 0 1 .6 1.16 1.16 0 0 0 .56-.14c1-.59 2.73-2.14 3.18-2.41Z",
    style: {
      opacity: 0.2,
      transformOrigin: "250.078px 214.725px"
    },
    className: "animable",
    id: "el3pjuwsxdkuw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 211.33a1.29 1.29 0 0 0-.79-.28 1.18 1.18 0 0 0-.67.21l-.09.06c-.26.22-.23.52.11.71a1.46 1.46 0 0 0 1.35 0 .47.47 0 0 0 .28-.39.41.41 0 0 0-.19-.31Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "253.233px 211.623px"
    },
    id: "elm2po3cfso6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.48 211.24.22.06a.75.75 0 0 0-.25-.13s-.08 0-.09 0 .09.06.12.07Z",
    style: {
      fill: "#fff",
      opacity: 0.25,
      transformOrigin: "253.53px 211.235px"
    },
    className: "animable",
    id: "elhrw6cfoub4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.66 211.36-.36-.05v-.19h-.2v.19a2 2 0 0 0-.35.06v.14a2 2 0 0 1 .35 0v.3h.2v-.3a2 2 0 0 1 .36 0Z",
    style: {
      opacity: 0.2,
      transformOrigin: "253.205px 211.465px"
    },
    className: "animable",
    id: "el0brcyrd8g9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.75 211.37a2 2 0 0 1 .35-.06v.07a1.34 1.34 0 0 0-.35.05Z",
    style: {
      opacity: 0.2,
      transformOrigin: "252.925px 211.37px"
    },
    className: "animable",
    id: "eleks03r4pie"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.66 211.36v.07a1.36 1.36 0 0 0-.36-.05v-.07Z",
    style: {
      opacity: 0.2,
      transformOrigin: "253.48px 211.37px"
    },
    className: "animable",
    id: "eljzkk022tb48"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "253.2px 211.16px"
    },
    className: "animable",
    d: "M253.1 211.12h.2v.08h-.2z",
    id: "elr5o8bo6wc2l"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pipeline--inject-2",
    className: "animable",
    style: {
      transformOrigin: "258.335px 391.91px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pipeline--inject-2",
    className: "animable",
    style: {
      transformOrigin: "258.335px 391.91px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.39 410.58c0-3.59 2.38-7.19 7.13-9.93 9.5-5.48 24.9-5.48 34.39 0 4.75 2.74 7.13 6.34 7.13 9.93v5.52c0 3.59-2.38 7.19-7.13 9.93-9.49 5.48-24.89 5.48-34.39 0-4.75-2.74-7.13-6.34-7.13-9.93Z",
    style: {
      fill: "#37474f",
      transformOrigin: "304.715px 413.34px"
    },
    id: "elkrsz25kj9g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.4 410.58c0 3.59 2.37 7.18 7.12 9.93 9.5 5.48 24.9 5.48 34.39 0 4.75-2.75 7.12-6.34 7.12-9.93a9.57 9.57 0 0 0-2.5-6.22v4.72a8.19 8.19 0 0 1-1.6 4.74 14.79 14.79 0 0 1-4.79 4.16c-8.52 4.92-22.33 4.92-30.85 0-4.26-2.46-6.39-5.68-6.39-8.9v-4.72a9.57 9.57 0 0 0-2.5 6.22Z",
    style: {
      fill: "#455a64",
      transformOrigin: "304.715px 414.49px"
    },
    id: "elv8xm99uaiz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.83 352.28a37.13 37.13 0 0 1 55.7 32.16v24.63c0 3.23-2.13 6.45-6.39 8.91-8.52 4.92-22.33 4.92-30.85 0-4.26-2.46-6.39-5.68-6.39-8.91V395.7L214 435.49l-21.85-37.79Z",
    style: {
      fill: "#37474f",
      transformOrigin: "259.34px 391.396px"
    },
    id: "el4da9rtpodot",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.57 397a16.49 16.49 0 0 1 4.49 1.82 28.14 28.14 0 0 1 7.47 6.56l22.05-12.74 27.28-15.74c3.13-1.8 11.79-6.78 13.06-7.43 5.61-2.92 12-5.44 18.05-5.92 4.77-.38 8.74.6 13.34 1.57 1.85.39 4.25.84 5.91-.35 1.95-1.4 1.6-4.31.53-6.17-3.82-6.59-14.34-8.75-21.35-8.75a34.69 34.69 0 0 0-17.28 4.69Z",
    style: {
      fill: "#fff",
      opacity: 0.05,
      transformOrigin: "255.094px 377.615px"
    },
    className: "animable",
    id: "elq7qhkxxcq7i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.9 420.83a27 27 0 0 1-7.61-2.85c-4.26-2.46-6.39-5.68-6.39-8.91V395.7l5.11-3a5.93 5.93 0 0 1 8.89 5.13Z",
    style: {
      opacity: 0.15,
      transformOrigin: "289.9px 406.369px"
    },
    className: "animable",
    id: "elk7ewpr3jhj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.49 425.51c0 9.83-6.91 13.82-15.43 8.9s-15.43-16.88-15.43-26.72 6.91-13.82 15.43-8.9 15.43 16.88 15.43 26.72Z",
    style: {
      fill: "#263238",
      transformOrigin: "203.06px 416.599px"
    },
    id: "el1e64dr2hbky",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 434c3.74 0 6-3.15 6-8.44 0-8.86-6.48-20.07-14.14-24.5a11.65 11.65 0 0 0-5.61-1.76c-3.74 0-6 3.15-6 8.44 0 8.86 6.48 20.07 14.14 24.5A11.65 11.65 0 0 0 210 434Z",
    id: "el5eeowafqhkf",
    className: "animable",
    style: {
      transformOrigin: "203.125px 416.65px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.37 405.83 4.79-2.77c3.11-1.79 5-5.65 5-11.13 0-11-7.7-24.3-17.19-29.78-4.75-2.75-9.05-3-12.17-1.21l-4.77 2.76-.34.21-.31.21-.35.26-.31.26-.23.21a6.37 6.37 0 0 0-.57.59c-.15.16-.29.34-.44.52s-.13.19-.19.28a10.56 10.56 0 0 0-.59.93l-.17.34c-.12.22-.22.46-.33.7l-.15.37c-.05.12-.09.24-.14.37l4.09-2.36a8.25 8.25 0 0 1 4.9-1 14.93 14.93 0 0 1 6 2.07c8.51 4.93 15.42 16.88 15.42 26.72 0 4.92-1.73 8.38-4.52 10l-4.08 2.36.39.06.39.05a7.28 7.28 0 0 0 .78.07h1.81c.22 0 .45-.07.67-.12a7.19 7.19 0 0 0 .8-.2l.29-.09.38-.14.4-.17.37-.2Z",
    style: {
      fill: "#455a64",
      transformOrigin: "261.035px 383.359px"
    },
    id: "elcm2q87b48b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.37 405.83c3.12-1.8 5-5.65 5-11.14 0-11-7.7-24.3-17.19-29.78-4.75-2.74-9.05-3-12.17-1.21a9.62 9.62 0 0 0-4.13 5.28l4.09-2.36a8.18 8.18 0 0 1 4.9-1 14.81 14.81 0 0 1 6 2.06c8.52 4.93 15.43 16.89 15.43 26.72 0 4.92-1.73 8.38-4.52 10l-4.08 2.36a9.55 9.55 0 0 0 6.67-.93Z",
    style: {
      fill: "#263238",
      transformOrigin: "258.625px 384.778px"
    },
    id: "elsuk5mrgmf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.47 426 4.78-2.76c3.11-1.8 5-5.65 5-11.13 0-11-7.7-24.3-17.2-29.79-4.75-2.74-9-3-12.16-1.2l-4.78 2.76-.34.21-.31.21a4 4 0 0 0-.35.26 3.48 3.48 0 0 0-.3.26l-.23.2c-.2.19-.39.38-.58.59l-.43.53-.2.27a9.86 9.86 0 0 0-.58.94 3.59 3.59 0 0 0-.17.34 5.68 5.68 0 0 0-.33.7 2.39 2.39 0 0 0-.15.37 3.18 3.18 0 0 0-.14.37l4.08-2.36a8.21 8.21 0 0 1 4.91-1 14.89 14.89 0 0 1 6 2.07c8.52 4.92 15.42 16.88 15.42 26.72 0 4.92-1.72 8.38-4.51 10l-4.09 2.35.39.07h.4c.26 0 .52.06.77.07h1.82l.67-.11c.28-.06.54-.12.8-.2l.29-.1a3.35 3.35 0 0 0 .38-.14 2.83 2.83 0 0 0 .4-.17l.34-.16Z",
    style: {
      fill: "#455a64",
      transformOrigin: "226.125px 403.512px"
    },
    id: "elbz29g4rr4jo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.47 426c3.11-1.79 5-5.65 5-11.13 0-11-7.7-24.3-17.2-29.79-4.75-2.74-9.05-3-12.16-1.2a9.55 9.55 0 0 0-4.14 5.28l4.09-2.36a8.18 8.18 0 0 1 4.9-1 14.88 14.88 0 0 1 6 2.07c8.51 4.92 15.42 16.88 15.42 26.72 0 4.92-1.72 8.38-4.51 10l-4.09 2.36a9.59 9.59 0 0 0 6.69-.95Z",
    style: {
      fill: "#263238",
      transformOrigin: "223.72px 404.956px"
    },
    id: "el54su2qn68sa",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pipe--inject-2",
    className: "animable",
    style: {
      transformOrigin: "166.91px 275.637px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m102.56 87.78 4.86 2.8-24.93 43.18-4.88-2.76c-3.19-1.84-5.16-5.79-5.16-11.41 0-11.24 7.89-24.91 17.63-30.53 4.92-2.88 9.29-3.14 12.48-1.28Z",
    style: {
      fill: "#455a64",
      transformOrigin: "89.935px 110.178px"
    },
    id: "elbfcaw8p8bnq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.33 122.35c0-11.25 7.89-24.92 17.63-30.54s17.62-1.06 17.62 10.18-7.89 24.91-17.58 30.53-17.67 1.07-17.67-10.17Z",
    style: {
      fill: "#37474f",
      transformOrigin: "94.955px 112.166px"
    },
    id: "elypwyxu65znh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.49 119.36c0-7.94 5.58-17.61 12.47-21.58s12.46-.78 12.46 7.22-5.58 17.59-12.42 21.56-12.51.75-12.51-7.2Z",
    style: {
      fill: "#37474f",
      transformOrigin: "94.955px 112.168px"
    },
    id: "el9ug0off4o09",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.61 99.88c0 8-5.58 17.62-12.47 21.59a13.13 13.13 0 0 1-3.14 1.31 13.22 13.22 0 0 1-.46-3.42c0-7.94 5.58-17.61 12.47-21.58a13.23 13.23 0 0 1 3.18-1.31 12.65 12.65 0 0 1 .42 3.41Z",
    style: {
      fill: "#263238",
      transformOrigin: "90.5756px 109.625px"
    },
    id: "elcvwthvmzqfj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pipe--inject-2",
    className: "animable",
    style: {
      transformOrigin: "174.38px 378.86px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.13 298.89v62.16a12 12 0 0 0 6 10.4l41.12 23.74c-13.81-1.68-28.79 13.1-43.57 25.18l-22.85-13.2a48.54 48.54 0 0 1-24.27-42v-66.28Z",
    style: {
      fill: "#455a64",
      transformOrigin: "151.905px 359.63px"
    },
    id: "elj9zbbswk83",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.56 298.89v49.36c.25 3 2.38 6 6.37 8.29 7.94 4.59 20.48 4.9 29 .92.61-.28 1.21-.59 1.78-.92 4.15-2.4 6.28-5.52 6.37-8.66v-49Z",
    style: {
      fill: "#455a64",
      transformOrigin: "128.32px 329.555px"
    },
    id: "el38e3hi5npuk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.3 365.37a39.43 39.43 0 0 0 19.54 34.05l27.42 16-8.58 5-22.85-13.2a48.54 48.54 0 0 1-24.27-42v-66.33h8.74Z",
    style: {
      fill: "#37474f",
      transformOrigin: "134.41px 359.655px"
    },
    id: "el2hjnsx552fg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171 395.13-26.93-15.55a17.86 17.86 0 0 1-8.93-15.48v-65.21h15v62.16a12 12 0 0 0 6 10.4l19.08 11Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "155.18px 347.01px"
    },
    className: "animable",
    id: "elzobtj9qmxl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.55 346.18v2.07c.25 3 2.38 6 6.37 8.29 7.94 4.59 20.48 4.9 29 .92.61-.28 1.21-.59 1.78-.92 4.15-2.4 6.28-5.52 6.37-8.66a1.34 1.34 0 0 0 0-.2v-1.47a1.34 1.34 0 0 1 0 .2c-.09 3.14-2.22 6.27-6.37 8.67-.57.33-1.17.64-1.78.92-8.56 4-21.1 3.66-29-.92-4-2.31-6.12-5.28-6.37-8.3v-.06c.01-.18 0-.36 0-.54Z",
    style: {
      fill: "#263238",
      transformOrigin: "128.312px 353.205px"
    },
    id: "eliahn7wrsxo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.13 321.58a1.31 1.31 0 1 0 1.31-1.3 1.31 1.31 0 0 0-1.31 1.3Zm-9.32 3.49a1.31 1.31 0 1 0 1.31-1.31 1.31 1.31 0 0 0-1.31 1.31Zm-22.87-3.49a1.31 1.31 0 1 0 1.31-1.3 1.31 1.31 0 0 0-1.31 1.3Zm9.32 3.49a1.31 1.31 0 1 0 1.31-1.31 1.31 1.31 0 0 0-1.31 1.31Z",
    style: {
      fill: "#263238",
      transformOrigin: "128.345px 323.33px"
    },
    id: "el1c7j5ssgi0j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.3 410.08 21.44 12.38a35.52 35.52 0 0 1 9.62-19.62l-19-11a37.69 37.69 0 0 1-12.06 18.24Zm21-10.27a1.3 1.3 0 1 1 .48 1.78 1.3 1.3 0 0 1-.44-1.78Zm-6.77 11.73a1.3 1.3 0 1 1 .47 1.78 1.3 1.3 0 0 1-.43-1.78Z",
    style: {
      fill: "#455a64",
      transformOrigin: "168.83px 407.15px"
    },
    id: "el84aie2audlw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.83 412.84a1.3 1.3 0 1 0-1.79.48 1.3 1.3 0 0 0 1.79-.48Z",
    style: {
      fill: "#455a64",
      transformOrigin: "168.699px 412.199px"
    },
    id: "elin9exybvi5m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.92 421.35a1.31 1.31 0 1 0 1.79-.48 1.32 1.32 0 0 0-1.79.48Z",
    style: {
      fill: "#455a64",
      transformOrigin: "167.055px 422.006px"
    },
    id: "eljxndg2oenr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.06 402.24v1a15.62 15.62 0 0 0 .45 3.13 9.69 9.69 0 0 0 .45 1.41c.07.17.13.33.2.49a8.82 8.82 0 0 0 .47.92c.08.14.17.28.26.42a8.18 8.18 0 0 0 .78 1 3.51 3.51 0 0 0 .33.34.81.81 0 0 0 .16.16 3.65 3.65 0 0 0 .3.27 4 4 0 0 0 .47.37 4.93 4.93 0 0 0 .61.4l4 2.3a16.72 16.72 0 0 0 6.61-2.31 26.2 26.2 0 0 0 3.13-2.13 37.69 37.69 0 0 0 12.08-18.2 28.75 28.75 0 0 0 1.28-8.22 17.3 17.3 0 0 0-1.29-6.88l-4-2.31c-3.86-2.24-9.77-.93-16 4.93a33.54 33.54 0 0 0-9.53 16.52 30.53 30.53 0 0 0-.65 3.71 23.92 23.92 0 0 0-.11 2.68Z",
    style: {
      fill: "#455a64",
      transformOrigin: "150.85px 393.91px"
    },
    id: "el96qeaqu1gxj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.56 414.52 179 435c-2.75-1.63-4.45-5.06-4.45-9.94a21 21 0 0 1 .16-2.6l-21.41-12.38a26.2 26.2 0 0 1-3.13 2.13 16.72 16.72 0 0 1-6.61 2.31Zm22.36 6.83a1.32 1.32 0 0 1 1.79-.48 1.31 1.31 0 1 1-1.79.48Z",
    style: {
      fill: "#37474f",
      transformOrigin: "161.28px 422.54px"
    },
    id: "elw7j3y9bykbc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.92 421.35a1.31 1.31 0 1 0 1.79-.48 1.32 1.32 0 0 0-1.79.48Z",
    style: {
      fill: "#37474f",
      transformOrigin: "167.055px 422.006px"
    },
    id: "el4wwh361zg05",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.06 402.24v1a15.62 15.62 0 0 0 .45 3.13 13 13 0 0 0 .45 1.41c.07.17.13.33.2.49.15.32.3.63.47.92.08.14.17.28.26.42a8.18 8.18 0 0 0 .78 1 3.51 3.51 0 0 0 .33.34.81.81 0 0 0 .16.16 3.65 3.65 0 0 0 .3.27 4 4 0 0 0 .47.37 4.93 4.93 0 0 0 .61.4l4 2.3a16.72 16.72 0 0 0 6.61-2.31 26.2 26.2 0 0 0 3.13-2.13l-4.06-2.35-13.34-7.66-.67-.39a23.92 23.92 0 0 0-.15 2.63Z",
    style: {
      fill: "#37474f",
      transformOrigin: "144.17px 407.03px"
    },
    id: "elefj1xq2ezbi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.8 380 .58.33 16.15 9.33 3.85 2.21 19 11a25.73 25.73 0 0 1 5.63-4.47c4.25-2.46 8.1-2.69 10.89-1.08l-35.51-20.51-4-2.31c-3.86-2.24-9.77-.93-16 4.93Zm37.2 13.48a1.3 1.3 0 1 1 .48 1.78 1.3 1.3 0 0 1-.48-1.78Z",
    style: {
      fill: "#455a64",
      transformOrigin: "172.85px 388.17px"
    },
    id: "eld3d8txyncre",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "172.85px 388.17px"
    },
    className: "animable",
    id: "elxoicfgriozm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m144.8 380 .58.33 16.15 9.33 3.85 2.21 19 11a25.73 25.73 0 0 1 5.63-4.47c4.25-2.46 8.1-2.69 10.89-1.08l-35.51-20.51-4-2.31c-3.86-2.24-9.77-.93-16 4.93Zm37.2 13.48a1.3 1.3 0 1 1 .48 1.78 1.3 1.3 0 0 1-.48-1.78Z",
    style: {
      fill: "#fff",
      transformOrigin: "172.85px 388.17px"
    },
    id: "eld85viu3mn6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 393.48a1.3 1.3 0 1 0 1.78-.48 1.3 1.3 0 0 0-1.78.48Z",
    style: {
      fill: "#fff",
      transformOrigin: "183.129px 394.125px"
    },
    id: "el5yb7sc0wf9",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M174.82 401.59a1.3 1.3 0 1 0-.48-1.78 1.3 1.3 0 0 0 .48 1.78Zm7.68-6.33a1.3 1.3 0 1 0-.48-1.78 1.3 1.3 0 0 0 .48 1.78ZM168 413.32a1.31 1.31 0 1 0-.47-1.78 1.31 1.31 0 0 0 .47 1.78Zm-1.64 9.82a1.31 1.31 0 1 0-.48-1.79 1.32 1.32 0 0 0 .52 1.79Z",
    style: {
      fill: "#263238",
      transformOrigin: "175.081px 408.073px"
    },
    id: "el3v8j0i0w3xn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.79 401.5c0 4.88 1.7 8.31 4.45 9.94l1.27.73c-2.77-1.61-4.49-5.06-4.49-10a20.85 20.85 0 0 1 .16-2.6 35.47 35.47 0 0 1 9.66-19.57 26.23 26.23 0 0 1 5.62-4.47c4.26-2.46 8.11-2.69 10.9-1.08l-1.27-.73c-2.79-1.61-6.64-1.38-10.89 1.08a25.73 25.73 0 0 0-5.63 4.47A35.52 35.52 0 0 0 134 398.9a21 21 0 0 0-.21 2.6Z",
    style: {
      fill: "#263238",
      transformOrigin: "147.575px 392.432px"
    },
    id: "eltx6ujdwovhl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.09 433.64 22 12.66a35.52 35.52 0 0 1 9.62-19.62l-19.52-11.24a37.69 37.69 0 0 1-12.1 18.2Zm21.58-10a1.3 1.3 0 1 1 .48 1.78 1.3 1.3 0 0 1-.48-1.77Zm-6.77 11.73a1.3 1.3 0 1 1 .47 1.78 1.3 1.3 0 0 1-.47-1.77Z",
    style: {
      fill: "#455a64",
      transformOrigin: "209.9px 430.87px"
    },
    id: "el4hnj21fs142",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.16 436.68a1.3 1.3 0 1 0-1.79.48 1.3 1.3 0 0 0 1.79-.48Z",
    style: {
      fill: "#455a64",
      transformOrigin: "210.029px 436.039px"
    },
    id: "elgyhkwpj3cac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.25 445.19a1.31 1.31 0 1 0 1.79-.48 1.32 1.32 0 0 0-1.79.48Z",
    style: {
      fill: "#455a64",
      transformOrigin: "208.385px 445.846px"
    },
    id: "elae6qe9gpiws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.85 425.8v1a15.62 15.62 0 0 0 .45 3.13 9.69 9.69 0 0 0 .45 1.41c.07.17.13.33.2.49a8.82 8.82 0 0 0 .47.92c.08.14.17.28.26.42a8.18 8.18 0 0 0 .78 1 3.51 3.51 0 0 0 .33.34.81.81 0 0 0 .16.16l.3.27a4 4 0 0 0 .47.37 4.93 4.93 0 0 0 .61.4l4 2.3a16.72 16.72 0 0 0 6.61-2.31 26.2 26.2 0 0 0 3.13-2.13 37.69 37.69 0 0 0 12.08-18.2 28.75 28.75 0 0 0 1.28-8.22 17.3 17.3 0 0 0-1.29-6.88l-4-2.31c-3.86-2.24-9.77-.93-16 4.93a33.54 33.54 0 0 0-9.53 16.52 30.53 30.53 0 0 0-.65 3.71 23.92 23.92 0 0 0-.11 2.68Z",
    style: {
      fill: "#455a64",
      transformOrigin: "191.64px 417.47px"
    },
    id: "ele9aejz29fea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.35 438.08 36 20.76c-2.75-1.63-4.45-5.06-4.45-9.94a21 21 0 0 1 .16-2.6l-22-12.66a26.2 26.2 0 0 1-3.13 2.13 16.72 16.72 0 0 1-6.58 2.31Zm22.9 7.11a1.32 1.32 0 0 1 1.79-.48 1.31 1.31 0 1 1-1.79.48Z",
    style: {
      fill: "#37474f",
      transformOrigin: "202.35px 446.24px"
    },
    id: "elh6yr86fes4s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.25 445.19a1.31 1.31 0 1 0 1.79-.48 1.32 1.32 0 0 0-1.79.48Z",
    style: {
      fill: "#37474f",
      transformOrigin: "208.385px 445.846px"
    },
    id: "elnvhcvektjn8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.85 425.8v1a15.62 15.62 0 0 0 .45 3.13 13 13 0 0 0 .45 1.41c.07.17.13.33.2.49.15.32.3.63.47.92s.17.28.26.42a8.18 8.18 0 0 0 .78 1 3.51 3.51 0 0 0 .33.34.81.81 0 0 0 .16.16l.3.27a4 4 0 0 0 .47.37 4.93 4.93 0 0 0 .61.4l4 2.3a16.72 16.72 0 0 0 6.61-2.31 26.2 26.2 0 0 0 3.13-2.13l-4.07-2.28-13.36-7.71-.67-.39a23.92 23.92 0 0 0-.12 2.61Z",
    style: {
      fill: "#37474f",
      transformOrigin: "184.96px 430.6px"
    },
    id: "elzjccae09pds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.59 403.57.58.33 16.15 9.33 3.85 2.21 19.52 11.24a25.73 25.73 0 0 1 5.63-4.47c4.25-2.46 8.1-2.69 10.89-1.08l-36.05-20.79-4-2.31c-3.86-2.24-9.77-.93-16 4.93Zm37.76 13.75a1.3 1.3 0 1 1 .48 1.78 1.3 1.3 0 0 1-.48-1.78Z",
    style: {
      fill: "#455a64",
      transformOrigin: "213.9px 411.84px"
    },
    id: "eljalbodyw4l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "213.9px 411.84px"
    },
    className: "animable",
    id: "elho3i7hjdsvh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m185.59 403.57.58.33 16.15 9.33 3.85 2.21 19.52 11.24a25.73 25.73 0 0 1 5.63-4.47c4.25-2.46 8.1-2.69 10.89-1.08l-36.05-20.79-4-2.31c-3.86-2.24-9.77-.93-16 4.93Zm37.76 13.75a1.3 1.3 0 1 1 .48 1.78 1.3 1.3 0 0 1-.48-1.78Z",
    style: {
      fill: "#fff",
      transformOrigin: "213.9px 411.84px"
    },
    id: "elkukasnujck9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.35 417.32a1.3 1.3 0 1 0 1.78-.48 1.3 1.3 0 0 0-1.78.48Z",
    style: {
      fill: "#fff",
      transformOrigin: "224.479px 417.965px"
    },
    id: "el6eafz3tvnii",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M216.15 425.43a1.3 1.3 0 1 0-.48-1.78 1.3 1.3 0 0 0 .48 1.78Zm7.68-6.33a1.3 1.3 0 1 0-.48-1.78 1.3 1.3 0 0 0 .48 1.78Zm-14.46 18.06a1.31 1.31 0 1 0-.47-1.78 1.31 1.31 0 0 0 .47 1.78Zm-1.64 9.84a1.31 1.31 0 1 0-.48-1.79 1.32 1.32 0 0 0 .48 1.79Z",
    style: {
      fill: "#263238",
      transformOrigin: "216.427px 431.923px"
    },
    id: "el3do0640f4l4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.58 425.06c0 4.88 1.7 8.31 4.45 9.94l1.27.73c-2.77-1.61-4.49-5.06-4.49-10a20.85 20.85 0 0 1 .16-2.6 35.47 35.47 0 0 1 9.63-19.61 26.23 26.23 0 0 1 5.62-4.47c4.26-2.46 8.11-2.69 10.9-1.08l-1.27-.73c-2.79-1.61-6.64-1.38-10.89 1.08a25.73 25.73 0 0 0-5.63 4.47 35.52 35.52 0 0 0-9.62 19.62 21 21 0 0 0-.13 2.65Z",
    style: {
      fill: "#263238",
      transformOrigin: "188.349px 415.972px"
    },
    id: "eljg2svfh3k3g",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m243.87 417.53 4.85 2.8-24.93 43.18-4.88-2.81c-3.18-1.84-5.16-5.79-5.16-11.41 0-11.24 7.9-24.91 17.63-30.53 4.88-2.83 9.3-3.09 12.49-1.23Z",
    style: {
      fill: "#37474f",
      transformOrigin: "231.235px 439.926px"
    },
    id: "elgfxbtc5vn68",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.63 452.1c0-11.25 7.89-24.92 17.63-30.54s17.63-1.06 17.63 10.18-7.9 24.91-17.63 30.53-17.63 1.07-17.63-10.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "236.26px 441.916px"
    },
    id: "elgkthhv1ag77",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.8 449.11c0-7.94 5.58-17.61 12.46-21.58s12.46-.76 12.46 7.19-5.58 17.62-12.46 21.59-12.46.75-12.46-7.2Z",
    style: {
      fill: "#37474f",
      transformOrigin: "236.26px 441.919px"
    },
    id: "el6ug8olp4jkj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.91 429.63c0 7.95-5.58 17.62-12.46 21.59a13.29 13.29 0 0 1-3.19 1.31 13.16 13.16 0 0 1-.46-3.42c0-7.94 5.58-17.61 12.46-21.58a13.13 13.13 0 0 1 3.19-1.31 13.08 13.08 0 0 1 .46 3.41Z",
    style: {
      fill: "#263238",
      transformOrigin: "231.855px 439.375px"
    },
    id: "eldigbowvd2a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.56 303.84v-5.6h49.86v5.63c0 3.68-2.43 7.37-7.3 10.18-9.73 5.62-25.52 5.62-35.25 0-4.87-2.82-7.33-6.52-7.31-10.21Z",
    style: {
      fill: "#37474f",
      transformOrigin: "128.49px 308.252px"
    },
    id: "elvy4wiz2llqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.11 308.41c-9.74 5.62-25.52 5.62-35.26 0s-9.73-14.73 0-20.35 25.52-5.62 35.26 0 9.73 14.73 0 20.35Z",
    style: {
      fill: "#455a64",
      transformOrigin: "128.48px 298.235px"
    },
    id: "el4nrf5co5z98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.94 305.43c-6.88 4-18 4-24.92 0S109.13 295 116 291s18-4 24.92 0 6.91 10.46.02 14.43Z",
    style: {
      fill: "#37474f",
      transformOrigin: "128.474px 298.215px"
    },
    id: "el57ifgzqan2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 301.22c6.88-4 18-4 24.93 0a13.13 13.13 0 0 1 2.72 2.11 13.26 13.26 0 0 1-2.73 2.1c-6.88 4-18 4-24.92 0a13 13 0 0 1-2.73-2.11 13.26 13.26 0 0 1 2.73-2.1Z",
    style: {
      fill: "#263238",
      transformOrigin: "128.46px 303.325px"
    },
    id: "elhzpta6ye0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "115.488px 162.351px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.7 231.56v-80.22a12 12 0 0 0-6-10.4l-11.51-6.64 21.73-37.8 15 8.7a48.55 48.55 0 0 1 24.28 42.06v84.3Z",
    style: {
      fill: "#455a64",
      transformOrigin: "119.695px 164.03px"
    },
    id: "elabnd2cf9dmm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.86 116.62a33.81 33.81 0 0 1 16.4 29v81.15l15-7.35v-72.16a48.45 48.45 0 0 0-16.46-36.44c-.8-.71-1.62-1.38-2.46-2a46.79 46.79 0 0 0-5.34-3.62l-15-8.7-3 13.33Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "129.13px 161.635px"
    },
    className: "animable",
    id: "el0x2vzph38azm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.24 215v-64.65a19.43 19.43 0 0 0-9.78-16.85l-7.82-4.41-8.45 5.21 11.51 6.64a12 12 0 0 1 6 10.4v59.94Z",
    style: {
      fill: "#37474f",
      transformOrigin: "102.215px 172.045px"
    },
    id: "elclr6omp5wyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.9 129.85-1.26-.76a35.58 35.58 0 0 1 9.59-19.66l3.72 2.18a37.78 37.78 0 0 1-12.05 18.24Zm-1.66-23.45a1.3 1.3 0 1 1 .47 1.78 1.3 1.3 0 0 1-.47-1.78Zm-6.75 11.75a1.3 1.3 0 1 1 .47 1.79 1.31 1.31 0 0 1-.47-1.79Z",
    style: {
      fill: "#455a64",
      transformOrigin: "100.631px 117.803px"
    },
    id: "eldn0962twtbg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.74 119.45a1.3 1.3 0 1 0-1.78.49 1.3 1.3 0 0 0 1.78-.49Z",
    style: {
      fill: "#455a64",
      transformOrigin: "91.6071px 118.812px"
    },
    id: "elvbbw8ct25z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.84 128a1.32 1.32 0 0 0 .48 1.79 1.29 1.29 0 0 0 1.78-.48 1.31 1.31 0 1 0-2.26-1.31Z",
    style: {
      fill: "#455a64",
      transformOrigin: "89.9993px 128.613px"
    },
    id: "elulpr3890oec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.72 122v1a15.62 15.62 0 0 0 .45 3.14 9.69 9.69 0 0 0 .44 1.41c.07.17.13.33.2.49a9 9 0 0 0 .47.93c.08.14.17.28.26.42a8.18 8.18 0 0 0 .78 1 3.51 3.51 0 0 0 .33.34.81.81 0 0 0 .16.16l.3.27a4 4 0 0 0 .47.37 4.17 4.17 0 0 0 .6.4l4 2.31a16.61 16.61 0 0 0 6.6-2.24 25.32 25.32 0 0 0 3.12-2.13 37.78 37.78 0 0 0 12-18.24 29.15 29.15 0 0 0 1.27-8.23 17.3 17.3 0 0 0-1.3-6.88l-4-2.31c-3.85-2.25-9.73-1-15.91 4.92a33.67 33.67 0 0 0-9.51 16.55 32.27 32.27 0 0 0-.64 3.72 23.92 23.92 0 0 0-.09 2.6Z",
    style: {
      fill: "#455a64",
      transformOrigin: "96.4439px 113.701px"
    },
    id: "elrzssa23lcz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.84 128a1.32 1.32 0 0 0 .48 1.79 1.29 1.29 0 0 0 1.78-.48 1.31 1.31 0 1 0-2.26-1.31Z",
    style: {
      fill: "#37474f",
      transformOrigin: "89.9993px 128.613px"
    },
    id: "elatbh54y3nc7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.72 122v1a15.62 15.62 0 0 0 .45 3.14c.13.5.28 1 .44 1.41.07.17.13.33.2.49.15.32.3.64.47.93.08.14.17.28.26.42a8.18 8.18 0 0 0 .78 1 3.51 3.51 0 0 0 .33.34.81.81 0 0 0 .16.16l.3.27a4 4 0 0 0 .47.37 4.17 4.17 0 0 0 .6.4l4 2.31a16.61 16.61 0 0 0 6.6-2.24 25.32 25.32 0 0 0 3.12-2.13l-4.05-2.36-13.32-7.72-.66-.39a23.92 23.92 0 0 0-.15 2.6Z",
    style: {
      fill: "#37474f",
      transformOrigin: "89.81px 126.82px"
    },
    id: "el3tcqabqcpvr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "101.316px 102.376px"
    },
    className: "animable",
    id: "el79ducnpnnoc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m110.92 96.5-4-2.31c-3.85-2.25-9.73-1-15.91 4.92l-.59.61.58.33 16.1 9.35 3.84 2.21a29.15 29.15 0 0 0 1.27-8.23 17.3 17.3 0 0 0-1.29-6.88Zm-3.77 4.86a1.3 1.3 0 1 1-.48-1.79 1.31 1.31 0 0 1 .48 1.79Z",
    style: {
      fill: "#fff",
      transformOrigin: "101.316px 102.376px"
    },
    id: "el9m8x7e65qrw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.89 100.06a1.3 1.3 0 0 0 2.26 1.3 1.31 1.31 0 0 0-.48-1.79 1.29 1.29 0 0 0-1.78.49Z",
    style: {
      fill: "#fff",
      transformOrigin: "106.022px 100.703px"
    },
    id: "elamkbup9cras",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.71 108.18a1.3 1.3 0 1 0-.47-1.78 1.3 1.3 0 0 0 .47 1.78Zm7.66-6.34a1.3 1.3 0 0 0 1.78-.48 1.31 1.31 0 0 0-.48-1.79 1.31 1.31 0 0 0-1.3 2.27ZM91 119.94a1.31 1.31 0 1 0-.47-1.79 1.31 1.31 0 0 0 .47 1.79Zm-1.64 9.83a1.29 1.29 0 0 0 1.78-.48 1.31 1.31 0 1 0-1.78.48Z",
    style: {
      fill: "#263238",
      transformOrigin: "98.0116px 114.69px"
    },
    id: "el187h0wn3pqv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.39 190.86a1.31 1.31 0 1 0 1.31 1.31 1.31 1.31 0 0 0-1.31-1.31Zm9.32 3.49a1.31 1.31 0 1 0 1.31 1.31 1.31 1.31 0 0 0-1.31-1.31Zm22.87-3.49a1.31 1.31 0 1 0 1.3 1.31 1.31 1.31 0 0 0-1.3-1.31Zm-9.32 3.49a1.31 1.31 0 1 0 1.3 1.31 1.31 1.31 0 0 0-1.3-1.31Z",
    style: {
      fill: "#263238",
      transformOrigin: "128.48px 193.915px"
    },
    id: "el8klolc33abu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.69 151.7v1.77a2.81 2.81 0 0 0 0 .29c.25 3 2.38 6 6.37 8.29a22.58 22.58 0 0 0 2.36 1.18 35.28 35.28 0 0 0 19.82 1.89 29.23 29.23 0 0 0 6.86-2.15c.61-.28 1.21-.59 1.78-.92 4.15-2.4 6.28-5.52 6.37-8.66a1.34 1.34 0 0 0 0-.2v-1.47a1.34 1.34 0 0 1 0 .2c-.09 3.14-2.22 6.27-6.37 8.67-.57.33-1.17.64-1.78.92a29.22 29.22 0 0 1-6.86 2.14 35.27 35.27 0 0 1-19.82-1.89 22.52 22.52 0 0 1-2.36-1.17c-4-2.31-6.12-5.28-6.37-8.3v-.06a4759667019585.45 4759667019585.45 0 0 0 0-.54Z",
    style: {
      fill: "#263238",
      transformOrigin: "128.47px 158.726px"
    },
    id: "elqelltxioomd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.67 103.88-1.28-.74-.26-.14a2.15 2.15 0 0 0-.26-.14c-2.74-1.3-6.37-.94-10.36 1.37a22 22 0 0 0-2.2 1.45 35.29 35.29 0 0 0-11.56 16.22 29.61 29.61 0 0 0-1.57 7c-.06.67-.09 1.34-.09 2 0 4.79 1.64 8.2 4.32 9.85l.16.11 1.28.73a.62.62 0 0 1-.17-.11c-2.68-1.65-4.32-5.06-4.32-9.85a19.24 19.24 0 0 1 .09-2 29 29 0 0 1 1.57-7 35.31 35.31 0 0 1 11.55-16.22 20.45 20.45 0 0 1 2.2-1.46c4-2.3 7.63-2.66 10.37-1.37l.24.13Z",
    style: {
      fill: "#263238",
      transformOrigin: "109.88px 121.852px"
    },
    id: "elpptty5v4fbg",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.7 248.71v48.73h43.57v-48.77c-.09 3.14-2.22 6.27-6.37 8.67-.57.33-1.17.64-1.78.92a29.22 29.22 0 0 1-6.86 2.14 35.27 35.27 0 0 1-19.82-1.89 22.52 22.52 0 0 1-2.36-1.17c-4-2.31-6.12-5.28-6.37-8.3v-.33Z",
    style: {
      fill: "#455a64",
      transformOrigin: "128.485px 273.055px"
    },
    id: "el3zexg39cyxh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.7 297.44c0 3.22 2.13 6.44 6.38 8.9l.57.31.58.3 1.21.55a35.19 35.19 0 0 0 19.82 1.91l1.17-.24c.59-.14 1.16-.28 1.73-.44s1.12-.34 1.66-.53l1.07-.4 1-.42h.07c.33-.14.65-.3 1-.46s.65-.34 1-.52c4.25-2.46 6.38-5.68 6.38-8.9v-48.83c-.09 3.14-2.22 6.27-6.37 8.67-.57.33-1.17.64-1.78.92a29.22 29.22 0 0 1-6.86 2.14 35.27 35.27 0 0 1-19.82-1.89 22.52 22.52 0 0 1-2.36-1.17c-4-2.31-6.12-5.28-6.37-8.3v48.4Z",
    style: {
      fill: "#455a64",
      transformOrigin: "128.52px 279.359px"
    },
    id: "elp5ipfxwyjwp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.7 297.44c0 3.22 2.13 6.44 6.38 8.9l.57.31.58.3 1.21.55v-49a22.52 22.52 0 0 1-2.36-1.17c-4-2.31-6.12-5.28-6.37-8.3v48.4Z",
    style: {
      fill: "#37474f",
      transformOrigin: "111.07px 278.265px"
    },
    id: "elmvch49lls8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.26 260.4v49l1.17-.24c.59-.14 1.16-.28 1.73-.44s1.12-.34 1.66-.53l1.07-.4 1-.42h.07c.33-.14.65-.3 1-.46s.65-.34 1-.52c4.25-2.46 6.38-5.68 6.38-8.9v-48.82c-.09 3.14-2.22 6.27-6.37 8.67-.57.33-1.17.64-1.78.92a29.22 29.22 0 0 1-6.93 2.14Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "142.8px 279.035px"
    },
    className: "animable",
    id: "eldpakqzt9qei"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.69 248.44v1.77a2.81 2.81 0 0 0 0 .29c.25 3 2.38 6 6.37 8.29a22.58 22.58 0 0 0 2.36 1.18 35.28 35.28 0 0 0 19.82 1.89 29.23 29.23 0 0 0 6.86-2.15c.61-.28 1.21-.59 1.78-.92 4.15-2.4 6.28-5.52 6.37-8.66a1.34 1.34 0 0 0 0-.2v-1.47a1.34 1.34 0 0 1 0 .2c-.09 3.14-2.22 6.27-6.37 8.67-.57.33-1.17.64-1.78.92a29.22 29.22 0 0 1-6.86 2.14 35.27 35.27 0 0 1-19.82-1.89 22.52 22.52 0 0 1-2.36-1.17c-4-2.31-6.12-5.28-6.37-8.3V249a4759667019592 4759667019592 0 0 0 0-.54Z",
    style: {
      fill: "#263238",
      transformOrigin: "128.47px 255.471px"
    },
    id: "elouvsysjzwhq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.39 289.53a1.31 1.31 0 1 0 1.31 1.31 1.31 1.31 0 0 0-1.31-1.31Zm9.32 3.49a1.31 1.31 0 1 0 1.31 1.31 1.31 1.31 0 0 0-1.31-1.33Zm22.87-3.49a1.31 1.31 0 1 0 1.3 1.31 1.31 1.31 0 0 0-1.3-1.31Zm-9.32 3.47a1.31 1.31 0 1 0 1.3 1.31 1.31 1.31 0 0 0-1.3-1.31Z",
    style: {
      fill: "#263238",
      transformOrigin: "128.48px 292.585px"
    },
    id: "elg6xj7q0ozd5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.7 199.77v48.73h43.57v-48.77c-.09 3.14-2.22 6.27-6.37 8.67-.57.33-1.17.64-1.78.92a29.22 29.22 0 0 1-6.86 2.14 35.27 35.27 0 0 1-19.82-1.89 22.52 22.52 0 0 1-2.36-1.17c-4-2.31-6.12-5.28-6.37-8.3v-.33Z",
    style: {
      fill: "#455a64",
      transformOrigin: "128.485px 224.115px"
    },
    id: "eluy1uv62l5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.7 248.5c0 3.22 2.13 6.44 6.38 8.9l.57.31.58.3 1.21.55a35.19 35.19 0 0 0 19.82 1.91l1.17-.24c.59-.14 1.16-.28 1.73-.44s1.12-.34 1.66-.53l1.07-.4 1-.42h.07c.33-.14.65-.3 1-.46s.65-.34 1-.52c4.25-2.46 6.38-5.68 6.38-8.9v-48.83c-.09 3.14-2.22 6.27-6.37 8.67-.57.33-1.17.64-1.78.92a29.22 29.22 0 0 1-6.86 2.14 35.27 35.27 0 0 1-19.82-1.89 22.52 22.52 0 0 1-2.36-1.17c-4-2.31-6.12-5.28-6.37-8.3v48.4Z",
    style: {
      fill: "#455a64",
      transformOrigin: "128.52px 230.419px"
    },
    id: "el7cxwe6xahhf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.7 248.5c0 3.22 2.13 6.44 6.38 8.9l.57.31.58.3 1.21.55v-49a22.52 22.52 0 0 1-2.36-1.17c-4-2.31-6.12-5.28-6.37-8.3v48.4Z",
    style: {
      fill: "#37474f",
      transformOrigin: "111.07px 229.325px"
    },
    id: "el6g9uvixn9dr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.26 211.46v49l1.17-.24c.59-.14 1.16-.28 1.73-.44s1.12-.34 1.66-.53l1.07-.4 1-.42h.07c.33-.14.65-.3 1-.46s.65-.34 1-.52c4.25-2.46 6.38-5.68 6.38-8.9v-48.82c-.09 3.14-2.22 6.27-6.37 8.67-.57.33-1.17.64-1.78.92a29.22 29.22 0 0 1-6.93 2.14Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "142.8px 230.095px"
    },
    className: "animable",
    id: "elk2f5wgh58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.69 199.5v1.8a2.81 2.81 0 0 0 0 .29c.25 3 2.38 6 6.37 8.29a22.58 22.58 0 0 0 2.36 1.18 35.28 35.28 0 0 0 19.82 1.89 29.23 29.23 0 0 0 6.86-2.15c.61-.28 1.21-.59 1.78-.92 4.15-2.4 6.28-5.52 6.37-8.66a1.34 1.34 0 0 0 0-.2v-1.47a1.34 1.34 0 0 1 0 .2c-.09 3.14-2.22 6.27-6.37 8.67-.57.33-1.17.64-1.78.92a29.22 29.22 0 0 1-6.86 2.14 35.27 35.27 0 0 1-19.82-1.89 22.52 22.52 0 0 1-2.36-1.17c-4-2.31-6.12-5.28-6.37-8.3V200a4759667019592 4759667019592 0 0 0 0-.54Z",
    style: {
      fill: "#263238",
      transformOrigin: "128.47px 206.526px"
    },
    id: "el0qhh8t2tcac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.39 240.59a1.31 1.31 0 1 0 1.31 1.31 1.31 1.31 0 0 0-1.31-1.31Zm9.32 3.49a1.31 1.31 0 1 0 1.31 1.3 1.31 1.31 0 0 0-1.31-1.3Zm22.87-3.49a1.31 1.31 0 1 0 1.3 1.31 1.31 1.31 0 0 0-1.3-1.31Zm-9.32 3.49a1.31 1.31 0 1 0 1.3 1.3 1.3 1.3 0 0 0-1.3-1.3Z",
    style: {
      fill: "#263238",
      transformOrigin: "128.48px 243.645px"
    },
    id: "el5xx50q2y5cn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.85 453.69a20.5 20.5 0 0 0-7.51-28l-.59-.34c-3.64-2.1-9.2-.87-15 4.64a31.52 31.52 0 0 0-9 15.54c-1.87 7.8-.15 13.23 3.48 15.33l.6.34a20.49 20.49 0 0 0 28-7.5Z",
    style: {
      fill: "#37474f",
      transformOrigin: "240.79px 444.167px"
    },
    id: "elko2ps8ekwmn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.93 446.72c-1 11.83 4.78 16.47 11.63 16.47a20.49 20.49 0 0 0 8.25-35c-7.81-5.73-18.7 4.62-19.88 18.53Z",
    style: {
      fill: "#455a64",
      transformOrigin: "245.213px 444.885px"
    },
    id: "elvnguv2o9ib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.06 433.73a10.8 10.8 0 0 0-6.55-3.6 4.08 4.08 0 0 0-3.77 1.29.82.82 0 0 0-.18.49.77.77 0 0 0 .22.44c1.06 1.26 2.86 1.53 4.4 2.1a16.08 16.08 0 0 1 3.47 1.91 11.62 11.62 0 0 1 3.29 3.82c.21.37.55 1.19 1.24 1.34s.75-.84.54-1.84a16.68 16.68 0 0 0-1.34-3.8 11 11 0 0 0-1.32-2.15Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "250.193px 435.799px"
    },
    className: "animable",
    id: "elszs02g218ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.48 459.91c1 .59 2.43.5 4-.4a12.48 12.48 0 0 0 5.65-9.78 4 4 0 0 0-1.66-3.65l-2.82-1.63c-1-.59-2.43-.5-4 .4a12.46 12.46 0 0 0-5.65 9.77 4 4 0 0 0 1.66 3.66Z",
    style: {
      fill: "#37474f",
      transformOrigin: "253.065px 452.18px"
    },
    id: "elc0jxyzow5n6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.89 446.86-2.81-1.62a9.5 9.5 0 0 0-1.58 1.35l2.82 1.62a9.44 9.44 0 0 1 1.57-1.35Zm2.07-1-2.79-1.61a6.24 6.24 0 0 0-1.06.39l2.8 1.61a4.78 4.78 0 0 1 1.09-.4Z",
    style: {
      fill: "#455a64",
      transformOrigin: "252.75px 446.23px"
    },
    id: "elhdyq5z6rs9j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.47 446.47a12.47 12.47 0 0 0-5.64 9.78c0 1.8.63 3.07 1.65 3.66s2.43.5 4-.4a12.48 12.48 0 0 0 5.65-9.78 3.45 3.45 0 0 0-5.65-3.26Z",
    style: {
      fill: "#455a64",
      transformOrigin: "254.511px 452.954px"
    },
    id: "elzy3mscoo47",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.46 446.08a4 4 0 0 0-4 .39 12.64 12.64 0 0 0-5.61 9.07v.7a10.39 10.39 0 0 1 .91-3.84 13.47 13.47 0 0 1 2-3.38 10.15 10.15 0 0 1 3-2.53 3.25 3.25 0 0 1 5.24 3 10.37 10.37 0 0 1-.71 3.84 13.36 13.36 0 0 1-1.92 3.44 10.29 10.29 0 0 1-2.87 2.71c.2-.11.39-.24.58-.37a12.62 12.62 0 0 0 5.05-9.4 4 4 0 0 0-1.67-3.63Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "254.498px 452.599px"
    },
    className: "animable",
    id: "elwbc1yf3cqr7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.18 458.74a6.12 6.12 0 1 0 6.12-10.61 1.18 1.18 0 0 0-.37-.14 3.28 3.28 0 0 0-2.69.45 9.58 9.58 0 0 0-4.33 7.5 3.25 3.25 0 0 0 1 2.55 1.26 1.26 0 0 0 .27.25Z",
    style: {
      fill: "#455a64",
      transformOrigin: "256.137px 453.72px"
    },
    id: "elppc9bxh2c8k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.08 457.15a5.13 5.13 0 0 1-7.45-.62c-1.74-2.27.37-6.5 3.91-8.59a4.07 4.07 0 0 0-1.3.5 9.58 9.58 0 0 0-4.33 7.5 3.25 3.25 0 0 0 1 2.55 1.07 1.07 0 0 0 .31.25 6.1 6.1 0 0 0 7.86-1.59Z",
    style: {
      fill: "#37474f",
      transformOrigin: "255.492px 453.74px"
    },
    id: "el7zffmkhs054",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.34 452.91a.54.54 0 0 1-.27.5c-.27 0-.51-.28-.64-.48a4.47 4.47 0 0 0-3-1.87c-.46-.07-1-.15-1.17-.58a.92.92 0 0 1 .43-1 2.77 2.77 0 0 1 3.43.27 2.06 2.06 0 0 1 .29.3 3.44 3.44 0 0 1 .66 1.2 4.64 4.64 0 0 1 .27 1.66Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "257.789px 451.21px"
    },
    className: "animable",
    id: "elg7vq9v0ppar"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--valve--inject-2",
    className: "animable",
    style: {
      transformOrigin: "80.2906px 201.923px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "87.7565px 208.466px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.41 223.81a3 3 0 0 0 2.7 0 1 1 0 0 0 .56-.78V193.9a.92.92 0 0 0-.56-.77 3 3 0 0 0-2.69 0 .94.94 0 0 0-.56.78V223a1 1 0 0 0 .55.81Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "87.765px 208.471px"
    },
    id: "eldi0by7iodzl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.41 223.81a3 3 0 0 0 2.7 0 1 1 0 0 0 .56-.78V193.9a.92.92 0 0 0-.56-.77 3 3 0 0 0-2.69 0 .94.94 0 0 0-.56.78V223a1 1 0 0 0 .55.81Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "87.765px 208.471px"
    },
    className: "animable",
    id: "elaes44t3fpyd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.41 193.12a.94.94 0 0 0-.56.78V223a1 1 0 0 0 .56.78 2.47 2.47 0 0 0 1 .28v-31.23a2.63 2.63 0 0 0-1 .29Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.3,
      transformOrigin: "86.63px 208.445px"
    },
    className: "animable",
    id: "el26e4f14bb03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.41 193.12a.82.82 0 0 0 0 1.56 3 3 0 0 0 2.69 0c.75-.44.75-1.14 0-1.56a3 3 0 0 0-2.69 0Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "87.7528px 193.9px"
    },
    id: "el3fru71jazyc",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "86.3506px 194.075px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.14 181.57a5.68 5.68 0 0 0-2.6-4.48 1.83 1.83 0 0 0-1.83-.18l-48.39 28a1.81 1.81 0 0 0-.76 1.67 5.76 5.76 0 0 0 2.6 4.48 1.83 1.83 0 0 0 1.83.18l48.4-28a1.8 1.8 0 0 0 .75-1.67Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "86.3506px 194.075px"
    },
    id: "ely6ymws26fb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.14 181.57a5.68 5.68 0 0 0-2.6-4.48 1.83 1.83 0 0 0-1.83-.18l-48.39 28a1.81 1.81 0 0 0-.76 1.67 5.76 5.76 0 0 0 2.6 4.48 1.83 1.83 0 0 0 1.83.18l48.4-28a1.8 1.8 0 0 0 .75-1.67Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "86.3506px 194.075px"
    },
    className: "animable",
    id: "elbnx7cv9feg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.16 211a1.83 1.83 0 0 0 1.83.18l48.4-28a1.8 1.8 0 0 0 .75-1.66 5.08 5.08 0 0 0-.52-2l-51.94 30a5.13 5.13 0 0 0 1.48 1.48Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.3,
      transformOrigin: "86.9151px 195.433px"
    },
    className: "animable",
    id: "elsdfcq9buwzf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.16 211c1.43.83 2.59.16 2.59-1.5a5.67 5.67 0 0 0-2.6-4.47c-1.44-.83-2.6-.16-2.59 1.49a5.76 5.76 0 0 0 2.6 4.48Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "62.155px 208.015px"
    },
    id: "eleyzi1fn1ahe",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "58.75px 210.692px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.43 214.54c0-5.74 4-12.71 9-15.57 2.5-1.42 4.74-1.55 6.37-.61l4.65 2.64c1.63.94 2.63 2.94 2.62 5.8 0 5.73-4.07 12.7-9 15.57-2.48 1.44-4.73 1.57-6.35.63L50 220.34c-1.57-.95-2.57-2.95-2.57-5.8Z",
    style: {
      fill: "#37474f",
      transformOrigin: "58.75px 210.679px"
    },
    id: "elh1f3f8hoeqe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 222.39c-5 2.88-9 .55-9-5.19s4-12.72 9-15.57 9-.54 9 5.19-4 12.7-9 15.57Z",
    style: {
      fill: "#455a64",
      transformOrigin: "61px 212.017px"
    },
    id: "elfwlso4vr3r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 220.21c-3.92 2.26-7.1.43-7.1-4.1a15.64 15.64 0 0 1 7.14-12.3c3.94-2.25 7.12-.42 7.1 4.11A15.77 15.77 0 0 1 61 220.21Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "61.02px 212.013px"
    },
    id: "elfso1qcynryp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "61.045px 208.465px"
    },
    id: "eldsumqld8bha",
    className: "animable",
    d: "m61.6 211.99-.55-7.05-.56 7.05h1.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.05 213.38c-.66.38-1.19.07-1.19-.68a2.61 2.61 0 0 1 1.19-2c.66-.38 1.19-.07 1.19.68a2.66 2.66 0 0 1-1.19 2Z",
    style: {
      fill: "#455a64",
      transformOrigin: "61.05px 212.04px"
    },
    id: "elxqxxbar3x6",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "88.605px 217.51px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.19 220.36a14.69 14.69 0 0 1 6.7-11.54c1.85-1.06 3.51-1.15 4.72-.46l3.41 2c1.21.69 2 2.18 2 4.3a14.81 14.81 0 0 1-6.7 11.53c-1.84 1.07-3.51 1.16-4.71.47l-3.44-2c-1.24-.66-1.98-2.19-1.98-4.3Z",
    style: {
      fill: "#37474f",
      transformOrigin: "88.605px 217.51px"
    },
    id: "el6e2tu5xqwr6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.27 226.17c-3.69 2.13-6.67.41-6.67-3.85a14.7 14.7 0 0 1 6.7-11.54c3.7-2.11 6.68-.39 6.67 3.86a14.81 14.81 0 0 1-6.7 11.53Z",
    style: {
      fill: "#455a64",
      transformOrigin: "90.285px 218.481px"
    },
    id: "elp5cpgug7xfc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.27 224.55c-2.91 1.68-5.27.32-5.27-3a11.59 11.59 0 0 1 5.29-9.1c2.93-1.68 5.28-.31 5.27 3a11.66 11.66 0 0 1-5.29 9.1Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "90.28px 218.501px"
    },
    id: "elhduelco6zla",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "90.28px 215.85px"
    },
    id: "elgyog6p4tukb",
    className: "animable",
    d: "m90.69 218.46-.41-5.22-.41 5.22h.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.28 219.49c-.48.28-.88.06-.88-.5a2 2 0 0 1 .88-1.52c.49-.28.88-.05.88.51a1.93 1.93 0 0 1-.88 1.51Z",
    style: {
      fill: "#455a64",
      transformOrigin: "90.28px 218.481px"
    },
    id: "elbxizbjtxed",
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2",
    className: "animable",
    style: {
      transformOrigin: "416.609px 297.352px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-2",
    className: "animable",
    style: {
      transformOrigin: "416.609px 297.352px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-2",
    className: "animable",
    style: {
      transformOrigin: "423.188px 352.17px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.48 268.53c2.9 30.77 4.24 72.94 4.24 72.94.25 2.33 1.93 6.31 3.23 17.83 1.37 12.16 1.88 25.33 1.88 25.33s-10.73 8.95-17.49 1.89c0 0-5.87-20.95-9.57-35.24-3.5-13.52-7.11-35.45-7.11-35.45l-3.66 20.5s.61 8.77.46 14.92c-.17 7.15-2.48 25.82-2.48 25.82-2 3.82-15.91 4.56-18.12-1.57 0 0-.72-29.76-1.07-38.35-.67-16.86-.55-49.58-.33-71.36Z",
    style: {
      fill: "#37474f",
      transformOrigin: "428.058px 327.511px"
    },
    id: "eldwwn1tx8nyd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.66 315.83 419.82 294s-8.17-1.07-12.41-4.84c0 0 2.78 5 10.5 6.89l3.78 19.9-1.69 20.38Z",
    style: {
      opacity: 0.2,
      transformOrigin: "415.535px 312.745px"
    },
    className: "animable",
    id: "elsn45ephd6k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.86 418.14c.35 1.58 1.55 4.6 8.14 5.48s13.55-1.33 16.73-4.45 3.15-5.74 4.81-7.19 4.21-3.4 4.83-4.43.11-3.53.11-3.53Z",
    style: {
      fill: "#263238",
      transformOrigin: "399.269px 413.917px"
    },
    id: "elj2l4n1line",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.87 373.29v2.21s1.28 2.21 7.36 3.23a17.57 17.57 0 0 0 10.77-1.66l.26-1.89s1.15-.2.87 2.15-2.46 16.67-2.65 19.67.82 6.24-.11 8.41-4.19 3.25-6.12 6.11-3 8.33-12.1 10.33-13.76-.52-15.66-2.75-.73-4.61 2.95-7.23c3.85-2.74 6.61-4.77 9.31-7 3.47-2.81 4.39-4.78 4.39-9.22 0-3.61-.37-17.85-.5-19.74s.17-2.62 1.23-2.62Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "400.382px 397.934px"
    },
    id: "elum9w55la1we",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.87 373.29v2.21s1.28 2.21 7.36 3.23a17.57 17.57 0 0 0 10.77-1.66l.26-1.89s1.15-.2.87 2.15-2.46 16.67-2.65 19.67.82 6.24-.11 8.41-4.19 3.25-6.12 6.11-3 8.33-12.1 10.33-13.76-.52-15.66-2.75-.73-4.61 2.95-7.23c3.85-2.74 6.61-4.77 9.31-7 3.47-2.81 4.39-4.78 4.39-9.22 0-3.61-.37-17.85-.5-19.74s.17-2.62 1.23-2.62Z",
    style: {
      opacity: 0.2,
      transformOrigin: "400.382px 397.934px"
    },
    className: "animable",
    id: "el8uvqzst4rcy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.89 430.31c.72 4 2.35 6.66 5.62 7.9s8-1.16 9.35-3.26 2.67-4.79 1.43-11Z",
    style: {
      fill: "#263238",
      transformOrigin: "456.338px 431.25px"
    },
    id: "el38ypk2og60j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.93 385 .41 1.49s3.11 1.46 8.86.79 8.63-2.68 8.63-2.68l-.09-1.91s1.22-.21 1.39 1.91c.26 3.2.27 17.25.37 21.82s2.29 9.37 3.76 13.41 2.72 11.79-3 15.57-10.68 1.23-12.3-4.74c-1.73-6.37-.94-16.28-2.12-21.72a210 210 0 0 0-6.55-20.74c-.96-2.33.64-3.2.64-3.2Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "451.741px 409.932px"
    },
    id: "elnjnwysgzds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.93 385 .41 1.49s3.11 1.46 8.86.79 8.63-2.68 8.63-2.68l-.09-1.91s1.22-.21 1.39 1.91c.26 3.2.27 17.25.37 21.82s2.29 9.37 3.76 13.41 2.72 11.79-3 15.57-10.68 1.23-12.3-4.74c-1.73-6.37-.94-16.28-2.12-21.72a210 210 0 0 0-6.55-20.74c-.96-2.33.64-3.2.64-3.2Z",
    style: {
      opacity: 0.2,
      transformOrigin: "451.741px 409.932px"
    },
    className: "animable",
    id: "elwmkckbiy0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-2",
    className: "animable",
    style: {
      transformOrigin: "416.609px 261.517px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-2",
    className: "animable",
    style: {
      transformOrigin: "376.142px 218.466px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.29 206.94c-6.57 1-7.7 2.69-17.42 11.09a71.57 71.57 0 0 1-14 9.78s-8.23 10-8.57 11.94-1 6.34 2.86 8.79c2.47 1.57 5.35.14 6.87.28 3.2.31 5.15-2.28 6.48-3.07 9-5.35 18-10.23 18-10.23Z",
    style: {
      fill: "#37474f",
      transformOrigin: "388.161px 228.111px"
    },
    id: "el48r3jodhj8p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.22 201.37c1.34-.8 1.59.44 2 .61 0 0-1.39-1.59.93-3 1.43-.85 2.13 1.15 2.16.88 0-.11-1.72-4.19-3.14-7.65-1.34-3.28-.18-4.22.36-4.48s1.08 0 2.32 2.35 4.9 9.54 5.73 11 1.42 2.18 1.95.25.95-3.53 2-4.64c1.76-1.85 3.14-1 2.86.38-.39 2-.36 4.35-.65 7.61-.15 1.7-.18 3.3-.38 4.47-.6 4.1 1.79 6 4.64 9.19 2.33 2.63 4.73 4.79 10.08 10.07 5.07 5 4.87 16.8-.14 18.87-5.75 2.38-8-.65-12.21-7-3.54-5.4-8.41-15.23-9.73-17.51s-1.81-3.67-3.64-4.78a13.37 13.37 0 0 1-5-5.55c-.66-1.15-1.92-3.27-2.73-5s-.91-2.94.08-3.67c1.33-1 1.72.48 1.85.33s-1.26-1.6.66-2.73Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "362.893px 217.869px"
    },
    id: "elh6qaiwlz0fr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.53 204.2c-1.86 1.82-3.18 6.76-2.38 10-2.32-3.39-1-8.42 2.38-10Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "355.757px 209.2px"
    },
    id: "elkf7jo23myq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.79 201c1.09 2 2.13 4.22 1.86 5.12a1.4 1.4 0 0 1-1.67 1.16 2.7 2.7 0 0 1-1.16-.63 2.34 2.34 0 0 1 .27 1.56 1.66 1.66 0 0 1-1.9.85 2.27 2.27 0 0 1-1.09-.92s.45 1.19 0 1.85a1.54 1.54 0 0 1-2.32-.19c.54.94 1.32 1.47 2.29 1s.74-1.24.74-1.24a1.7 1.7 0 0 0 1.9 0 1.74 1.74 0 0 0 1-1.83 1.61 1.61 0 0 0 2.52-.85c.43-1.24 0-2.13-.8-3.56a10 10 0 0 0-1.64-2.32Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "351.09px 205.987px"
    },
    id: "elfp6onghln47",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M434.47 204.9c3.1.64 7 1.44 11 2.53s4.53 1.33 5.82 1.78c0 0 2.1 9 .87 30.72-.19 3.21-2.51 11.83-2.91 18.49a106.44 106.44 0 0 0 .56 20.77s-7.91 7.61-29.83 6c-17.21-1.29-21.67-8.8-21.67-8.8s.19-27.52.64-40.21c.59-16.66 5.63-26.28 9.35-29.2l11.29-1.88Z",
    style: {
      fill: "#455a64",
      transformOrigin: "425.428px 245.157px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-2",
    className: "animable",
    style: {
      transformOrigin: "425.035px 225.667px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439 169.28s2.66.2 4.4 3.55c.87 1.68 1.5 4.75-.9 13.51a35.52 35.52 0 0 1-4.21 9.67 4.36 4.36 0 0 1-2.52 2l.18-6.74.25-4.69s-3.79-3.44-4.11-6.81a10.81 10.81 0 0 1 1.27-6.8Z",
    style: {
      fill: "#37474f",
      transformOrigin: "438.081px 183.645px"
    },
    id: "elrl0kyrp8l7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.87 169.51c-.66-3.79-5.46-8.31-14.73-8.8-7.59-.41-11.81 2.34-14.67 6.63-3 4.48-.9 10.16-.9 10.16l23.85-1.56Z",
    style: {
      fill: "#37474f",
      transformOrigin: "424.363px 169.085px"
    },
    id: "ela87izyzo1gr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.05 193.26c-3.49 1.69-5.08-1.07-5.08-1.07l-.52 13.89c-6.71 9-24.59 5.73-17.25-1v-3.17a19.84 19.84 0 0 1-3-.29c-3.09-.49-5-2.94-5.95-6.29a46.72 46.72 0 0 1 0-21.31c.36-1.63 1.06-3.4 2.56-4.14 3.71-1.83 7.14.81 12.3 2.83 2.14.83 7.33 1.2 8.7.55-1.8 2-1.79 8.28.87 10.83a5.67 5.67 0 0 0 1.33 1.74c1.13 1 2.06-1.56 3-2.55a3.89 3.89 0 0 1 6 1.39 6.35 6.35 0 0 1-2.96 8.59Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "427.352px 190.425px"
    },
    id: "el6zos1puzmzy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.2 205.09s-5.15 4-8 15.08-3.66 43.07-3.75 53.59 0 14.43 0 14.43a34.9 34.9 0 0 1-10.62-2.59c0-12.34-.84-48.4 2.67-62s8.83-16.7 8.83-16.7Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "407.971px 246.64px"
    },
    id: "elv5jvbzejn48",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.73 275.52a24.89 24.89 0 0 0 10.64 3.34v-3.58a25.46 25.46 0 0 1-10.68-3.62c.03 1.34.04 2.62.04 3.86Zm0-14.63v4.24a25.77 25.77 0 0 0 10.77 3.77c0-1.16 0-2.43.08-3.76a41.51 41.51 0 0 1-10.85-4.25Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "402.135px 269.875px"
    },
    id: "el8muqy4fejnp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.5 204.6-.05 1.48s-4.67 17.51-5.8 32.26c-1.19 15.39-1.19 56.84-1.19 56.84s18.62-.73 22.12-4.77c-.9-15.37-1.89-22.75-1.09-33.76s5.36-31.51 1.09-47.85c-3.87-1.06-10.06-2.93-15.08-4.2Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "441.42px 249.89px"
    },
    id: "elbdecyu2jw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.55 274.64c-2.58 1.3-9.69 4.36-21 5.36v3.93s13-.24 21.3-5.45c-.14-1.33-.23-2.61-.3-3.84Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "440.2px 279.285px"
    },
    id: "el2bzqvf04azh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.21 201.92a28 28 0 0 0 10.05-1.53c2.39-1 4.51-4.24 5.21-7.46 0 2.59-1.14 7.17-4.77 9.07s-7.85 2-10.5 2.07Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "426.835px 198.5px"
    },
    id: "elr481vh4xhy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.09 181.51c1 1.89-.13 7.83-1.91 8.58s-3.64-.47-7.68-.7a29.34 29.34 0 0 0-9 .74c-1.82.5-5.11 1.33-5.25-.5.1 4.53 1 9.68 4.27 11.34s11.72 2 16.08-.23 5.16-4.88 6-8.42a65.68 65.68 0 0 1 2.24-7.34Z",
    style: {
      fill: "#37474f",
      transformOrigin: "423.545px 191.912px"
    },
    id: "el2de3kijrmrh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.05 177.88 3.43 1.44a1.94 1.94 0 0 0-1-2.49 1.82 1.82 0 0 0-2.43 1.05Z",
    style: {
      fill: "#37474f",
      transformOrigin: "426.835px 178.001px"
    },
    id: "elyysgn3qfo3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412.23 177.8 3.48-1.39a1.8 1.8 0 0 0-2.37-1.09 2 2 0 0 0-1.11 2.48Z",
    style: {
      fill: "#37474f",
      transformOrigin: "413.917px 176.496px"
    },
    id: "elfvxn4r5pba8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.14 182.19a1.51 1.51 0 1 1-1.46-1.57 1.51 1.51 0 0 1 1.46 1.57Z",
    style: {
      fill: "#263238",
      transformOrigin: "425.631px 182.129px"
    },
    id: "el8pde08k2mgf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.15 181.57a1.52 1.52 0 1 1-1.46-1.57 1.38 1.38 0 0 1 1.46 1.57Z",
    style: {
      fill: "#263238",
      transformOrigin: "413.637px 181.518px"
    },
    id: "elwqns7ltmcp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.84 178.83-1.25 9.64-5.1-1.88a22.58 22.58 0 0 1 6.35-7.76Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "417.665px 183.65px"
    },
    id: "el0xkifo0o8vae",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.94 190.92-3.95 1.3a2 2 0 0 0 2.59 1.39 2.17 2.17 0 0 0 1.36-2.69Z",
    style: {
      fill: "#b16668",
      transformOrigin: "421.013px 192.32px"
    },
    id: "el4h4ei7jczj6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.52 191.63a2.18 2.18 0 0 1 .5 0 2.14 2.14 0 0 1-1.44 2 1.88 1.88 0 0 1-.66.09 1.9 1.9 0 0 1 1.6-2.09Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "421.964px 192.669px"
    },
    id: "eldia8b668zjt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.93 177.77a18.44 18.44 0 0 1-1.6 5c-.35-.51-.76-1-1.17-1.5a31 31 0 0 0-8.52-6.77c-7.43-4.12-16.76-6-24.44-4.41a17.85 17.85 0 0 1 1.7-4.21 18.29 18.29 0 0 1 34.05 11.85Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "427.199px 169.603px"
    },
    id: "el2tbple9tghd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.29 159.07c-.88-.51-5.39-2.2-5.75-2.33-2.33-.89-6.16-1.11-10.32 1.86a18.56 18.56 0 0 0-6.83 9.52l4.78 1.86 1.55.26c.82-3.55 6.09-11 12.76-10.8a5 5 0 0 1 .94.08 8.56 8.56 0 0 1 2.54.7 24.35 24.35 0 0 1 2.44 2.24 4.09 4.09 0 0 0-2.11-3.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "427.895px 163.197px"
    },
    id: "el9lyiqhi6gl5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.29 159.07c-.88-.51-5.39-2.2-5.75-2.33-2.33-.89-6.16-1.11-10.32 1.86a18.56 18.56 0 0 0-6.83 9.52l4.78 1.86 1.55.26c.82-3.55 6.09-11 12.76-10.8a5 5 0 0 1 .94.08 8.56 8.56 0 0 1 2.54.7 24.35 24.35 0 0 1 2.44 2.24 4.09 4.09 0 0 0-2.11-3.39Z",
    style: {
      fill: "#fff",
      opacity: 0.45,
      transformOrigin: "427.895px 163.197px"
    },
    className: "animable",
    id: "el2as494i1sgp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.72 170.24c1-4.13 8-13.59 16.24-10a25.83 25.83 0 0 1 2.45 2.25 4.12 4.12 0 0 0-2.12-3.39c-2.12-1.2-6.48-2-11.29 1.4a18.56 18.56 0 0 0-6.83 9.52Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "430.29px 164.154px"
    },
    id: "elcsoq0doxbm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.72 170.24c1-4.13 8-13.59 16.24-10a25.83 25.83 0 0 1 2.45 2.25 4.12 4.12 0 0 0-2.12-3.39c-2.12-1.2-6.48-2-11.29 1.4a18.56 18.56 0 0 0-6.83 9.52Z",
    style: {
      opacity: 0.3,
      transformOrigin: "430.29px 164.154px"
    },
    className: "animable",
    id: "eljiem2rhkchs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.86 173.11a20.43 20.43 0 0 0-7.63-7.77c-3.61-2.26-11.28-2.89-14.73-3.07-6-.31-7.56.87-7.7 1.75 0 .21-.18 1.18-.22 1.4a.86.86 0 0 0 .08.58c.81 1.43 5.52 4.13 5.52 4.13 7.68-1.57 17 .29 24.44 4.41Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "418.71px 168.38px"
    },
    id: "elp0v1w4z072",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.86 173.11a20.43 20.43 0 0 0-7.63-7.77c-3.61-2.26-11.28-2.89-14.73-3.07-6-.31-7.56.87-7.7 1.75 0 .21-.18 1.18-.22 1.4a.86.86 0 0 0 .08.58c.81 1.43 5.52 4.13 5.52 4.13 7.68-1.57 17 .29 24.44 4.41Z",
    style: {
      opacity: 0.15,
      transformOrigin: "418.71px 168.38px"
    },
    className: "animable",
    id: "elax40pr51icd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.62 174.54c-7.43-4.12-16.76-6-24.44-4.41 0 0-4.71-2.7-5.52-4.13-.43-.79.14-2.69 7.61-2.3 3.44.18 11.11.81 14.72 3.06a20.41 20.41 0 0 1 7.63 7.78Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "418.587px 169.094px"
    },
    id: "elzw5rznhbpp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.62 174.54c-7.43-4.12-16.76-6-24.44-4.41 0 0-4.71-2.7-5.52-4.13-.43-.79.14-2.69 7.61-2.3 3.44.18 11.11.81 14.72 3.06a20.41 20.41 0 0 1 7.63 7.78Z",
    style: {
      opacity: 0.3,
      transformOrigin: "418.587px 169.094px"
    },
    className: "animable",
    id: "els8j26ogkzd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm-with-scissors--inject-2",
    className: "animable",
    style: {
      transformOrigin: "461.632px 240.665px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450 208.76c4 1 10.13 2 12.9 9.23 2.29 6 7.29 20.47 9.81 27.42 3.62 10 4.82 15.4 4.23 17.06-1.35 3.82-3.44 4.56-18.22 10.1-.75-4.59-6.28-11-8.62-11.7l7.4-5.33-9.44-20.54s-5.32-19 1.94-26.24Z",
    style: {
      fill: "#37474f",
      transformOrigin: "461.632px 240.665px"
    },
    id: "elbq7u1np36br",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m467.68 168.06 5.18.39-5.32 23.79 3.66 7.48 3.29-1.28 5.39-24 5.18.39c.32.54.63 1.1.93 1.71 5.19 10.61 4 27.22-2.63 37.1-3.35 5-7.45 7.29-11.35 7l-5.16-.39c-.32 0-.64-.07-1-.12L388.86 333c1.25 9.37-.68 20-5.49 27.16-2.49 3.7-5.39 5.93-8.32 6.72l-5.18-.39 5.33-23.8-3.66-7.48-3.3 1.28-5.39 24-5.18-.39c-.32-.54-.62-1.1-.92-1.7-5.19-10.61-4-27.23 2.63-37.11 3.31-4.92 7.35-7.23 11.21-7h.16l5 .37a8.08 8.08 0 0 1 1.1.15l77.05-112.94c-1.25-9.36.69-20 5.49-27.15 2.46-3.65 5.36-5.87 8.29-6.66Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "421.37px 267.47px"
    },
    id: "eld9fvudu54n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.68 168.06 5.18.39-5.32 23.79 3.66 7.48 3.29-1.28 5.39-24 5.18.39c.32.54.63 1.1.93 1.71 5.19 10.61 4 27.22-2.63 37.1-3.35 5-7.45 7.29-11.35 7l-5.16-.39c-.32 0-.64-.07-1-.12L388.86 333c1.25 9.37-.68 20-5.49 27.16-2.49 3.7-5.39 5.93-8.32 6.72l-5.18-.39 5.33-23.8-3.66-7.48-3.3 1.28-5.39 24-5.18-.39c-.32-.54-.62-1.1-.92-1.7-5.19-10.61-4-27.23 2.63-37.11 3.31-4.92 7.35-7.23 11.21-7h.16l5 .37a8.08 8.08 0 0 1 1.1.15l77.05-112.94c-1.25-9.36.69-20 5.49-27.15 2.46-3.65 5.36-5.87 8.29-6.66Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "421.37px 267.47px"
    },
    className: "animable",
    id: "el4pdim5thuhv"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      opacity: 0.4,
      transformOrigin: "466.78px 196.6px"
    },
    className: "animable",
    d: "m467.54 192.24-5.18-.39 4.65 9.5 4.19-1.63-3.66-7.48z",
    id: "el2vvw4xr89jq"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      opacity: 0.4,
      transformOrigin: "367.3px 334.85px"
    },
    className: "animable",
    d: "m368.24 336.5-5.18-.38 7.49-2.92.99 2.02-3.3 1.28z",
    id: "eldzjuitn6q2o"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      opacity: 0.4,
      transformOrigin: "425.29px 275.62px"
    },
    className: "animable",
    d: "m388.86 333.01-5.18-.39 78.04-114.39 5.18.39-78.04 114.39z",
    id: "elfeg8vlqakrq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.83 316.32 78-114.39c-1.25-9.36.69-20 5.49-27.15 2.49-3.71 5.39-5.93 8.32-6.72l-5.32 23.8 4.65 9.5 7.48-2.92 5.39-24c.32.54.63 1.11.92 1.71 5.2 10.61 4 27.22-2.62 37.1-4.87 7.24-11.31 8.83-16.46 5l-78 114.39c1.25 9.37-.68 20-5.49 27.16-2.49 3.7-5.39 5.93-8.32 6.72l5.33-23.8-4.65-9.5-7.49 2.92-5.39 24c-.32-.54-.62-1.1-.92-1.7-5.19-10.61-4-27.23 2.63-37.11 4.87-7.24 11.31-8.83 16.45-5.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "418.757px 267.29px"
    },
    id: "el7vfcqjblno",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.83 316.32 78-114.39c-1.25-9.36.69-20 5.49-27.15 2.49-3.71 5.39-5.93 8.32-6.72l-5.32 23.8 4.65 9.5 7.48-2.92 5.39-24c.32.54.63 1.11.92 1.71 5.2 10.61 4 27.22-2.62 37.1-4.87 7.24-11.31 8.83-16.46 5l-78 114.39c1.25 9.37-.68 20-5.49 27.16-2.49 3.7-5.39 5.93-8.32 6.72l5.33-23.8-4.65-9.5-7.49 2.92-5.39 24c-.32-.54-.62-1.1-.92-1.7-5.19-10.61-4-27.23 2.63-37.11 4.87-7.24 11.31-8.83 16.45-5.01Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "418.757px 267.29px"
    },
    className: "animable",
    id: "eliplkldffsvc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.38 216-65.3 95.7a9.15 9.15 0 0 0-.9 8.14c1.06 2.22 3.18 2.17 4.73-.11L453.22 224c1.55-2.28 1.95-5.92.89-8.12s-3.18-2.13-4.73.12Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.2,
      transformOrigin: "418.658px 267.872px"
    },
    className: "animable",
    id: "el7b1y7q2bya4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.72 311.91 452 216.22a4.48 4.48 0 0 1 1.34-1.34 3.3 3.3 0 0 1 .75 1c1.06 2.2.66 5.84-.89 8.12l-65.31 95.73a4.58 4.58 0 0 1-1.33 1.34 3.59 3.59 0 0 1-.76-1 9.15 9.15 0 0 1 .92-8.16Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.2,
      transformOrigin: "419.959px 267.975px"
    },
    className: "animable",
    id: "elpm9keibqu9h"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      opacity: 0.2,
      transformOrigin: "364.605px 346.865px"
    },
    className: "animable",
    d: "m371.54 335.22-.99-2.02-7.49 2.92-5.39 24.02 5.18.39 5.39-24.03 3.3-1.28z",
    id: "elm6hjhsnsu6c"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "464.585px 184.705px"
    },
    className: "animable",
    d: "m467.68 168.06-5.32 23.79 4.65 9.5-5.52-9.3 6.19-23.99z",
    id: "elc3iyiplqs4l"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "373.085px 349.85px"
    },
    className: "animable",
    d: "m369.87 366.5 6.43-24-5.75-9.3 4.65 9.5-5.33 23.8z",
    id: "ele804qvqfdls"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.72 272.57c-6.36 2.88-13.84 6.25-16.46 7.33a32.72 32.72 0 0 1-13 2.37c-3.7 0-6.32.14-9.33-2.83a16.71 16.71 0 0 1-4.44-7.72c-.18-1.07 1.69-2.59 1.69-2.59s.26-2.3 3.16-1.85 4.53 2.37 7.45 2.45a12.33 12.33 0 0 0 4.62-.6l2.23-3.27a34.77 34.77 0 0 1 3.57 1.61c.78.3 6.71-3.31 11.84-6.6 2.39.68 7.95 7.13 8.67 11.7Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "437.099px 271.574px"
    },
    id: "elknsrrbem55l",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2",
    className: "animable animator-active",
    style: {
      transformOrigin: "423.31px 112.046px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "423.31px 112.046px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "423.31px 112.046px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m419.36 144 3.58-6.73-2.88-8.27v-5.09l8.81 5.09v5.09l-3.78 6.56a.57.57 0 0 1-.26.23Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "424.115px 133.955px"
    },
    id: "elhrcyvmhomts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.36 144 3.58-6.73-2.88-8.27v-5.09l8.81 5.09v5.09l-3.78 6.56a.57.57 0 0 1-.26.23Z",
    style: {
      opacity: 0.3,
      transformOrigin: "424.115px 133.955px"
    },
    className: "animable",
    id: "el2hqid8wtnh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.54 86.48a5.86 5.86 0 0 1 2.64-4.58l2.15-1.24a5.87 5.87 0 0 1 5.29 0l26.81 15.45a5.84 5.84 0 0 1 2.65 4.58V137a5.84 5.84 0 0 1-2.65 4.58l-2.15 1.24a5.81 5.81 0 0 1-5.29 0l-9.65-5.56-3.78 6.56a.58.58 0 0 1-1-.1l-4-11.54-8.36-4.81a5.83 5.83 0 0 1-2.64-4.57Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "423.31px 112.046px"
    },
    id: "eljmpzew723an",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.08 137a5.84 5.84 0 0 1-2.65 4.58l-2.15 1.24a5.89 5.89 0 0 1-4.83.22c1.24.47 2.19-.24 2.19-1.74V105a5.39 5.39 0 0 0-.78-2.6l7.44-4.3a5.43 5.43 0 0 1 .78 2.61Z",
    style: {
      opacity: 0.3,
      transformOrigin: "438.265px 120.777px"
    },
    className: "animable",
    id: "elgdrkv3unxhr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.62 85.73c.31-1.12 1.34-1.48 2.56-.78L433 100.41a5.29 5.29 0 0 1 1.86 2l7.43-4.29a5.29 5.29 0 0 0-1.86-2l-26.81-15.46a5.87 5.87 0 0 0-5.29 0l-2.15 1.25a5.82 5.82 0 0 0-2.56 3.82Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "422.955px 91.2202px"
    },
    className: "animable",
    id: "ely7t26e3r38q"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Check--inject-2",
    className: "animable",
    style: {
      transformOrigin: "420.271px 115.074px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.84 125.44h-.32a2.38 2.38 0 0 1-1.84-1.35L408.92 114a2.39 2.39 0 1 1 4.32-2l3.19 6.77 11-12.77a2.39 2.39 0 1 1 3.57 3l-13.38 15.58a2.4 2.4 0 0 1-1.78.86Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "420.271px 115.074px"
    },
    id: "elembjb9xj07q",
    className: "animable"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotUpdated);
export default __webpack_public_path__ + "static/media/notUpdated.298694120a8581d5ada7fa4f156a50ac.svg";
export { ForwardRef as ReactComponent };